<template>
  <div class="content full">
    <e-breadcrumbs />
    <win-layer-pop class="sample_popup_list">
      <component
        v-if="customComponent"
        :is="customComponent"
        @close="closePopup"
        :parent-info="parentInfo"
      />
    </win-layer-pop>
    <h1 class="page_title">{{ $t('cp.CTRL020G070.001') }}</h1>
    <span style="font-size: 17px">{{ $t('cp.CTRL020G070.173') }}</span>
    <div class="content_box mt10">
      <table class="tbl_search">
        <colgroup>
          <col width="100px">
          <col>
          <col width="100px">
          <col>
        </colgroup>
        <tbody>
          <tr>
            <th>{{ $t('cp.CTRL020G070.002') }}</th>
            <td>{{ scenarioCd }}</td>
            <th>{{ $t('cp.CTRL020G070.003') }}</th>
            <td>{{ targetInfo.scenarioNm }}</td>
          </tr>
          <tr>
            <th>{{ $t('cp.CTRL020G070.004') }}</th>
            <td>{{ targetInfo.createUser }}</td>
            <th>{{ $t('cp.CTRL020G070.005') }}</th>
            <td>{{ targetInfo.category }}</td>
          </tr>
        </tbody>
      </table>
    </div>
    <div class="content_box mt10">
      <h2 class="content_title">{{ $t('cp.CTRL020G070.006') }}</h2>
      <p class="tit_label mb10">
        <input type="checkbox" name="allShipperYn" id="allShipperYn" v-model="targetInfo.allShipperYn" true-value="Y" false-value="N" @click.prevent="checkAllShipperState()">
        <label for="allShipperYn" class="mr10"><span>{{ $t('cp.CTRL020G070.007') }}</span></label>
        <span class="position_relative">
          <button type="button" class="tbl_icon help" @click="isShowHelp1 = !isShowHelp1">help</button>
          <div v-show="isShowHelp1" class="tooltip_wrap short position_absolute" style="min-width:150px; left:0; top:24px;">
            <div class="cont">
              <button type="button" class="close" @click="isShowHelp1 = false">close</button>
              <ul class="bul_list_sm t2" style="white-space: nowrap">
                <li>
                  <p v-for="(line, idx) in $t('cp.CTRL020G070.008').split('\n')" :key="idx">
                    {{ line }}
                  </p>
                </li>
              </ul>
            </div>
          </div>
        </span>
      </p>
      <table class="tbl_col">
        <colgroup>
          <col width="7.69%">
          <col width="7.69%">
          <col width="7.69%">
          <col width="7.69%">
          <col width="7.69%">
          <col width="7.69%">
          <col width="7.69%">
          <col width="7.69%">
          <col width="7.69%">
          <col width="7.69%">
          <col width="7.69%">
          <col width="7.69%">
          <col width="7.72%">
        </colgroup>
        <thead>
          <tr>
            <th>{{ $t('cp.CTRL020G070.009') }}<br>{{ $t('cp.CTRL020G070.011') }}</th>
            <th>{{ $t('cp.CTRL020G070.009') }}<br>{{ $t('cp.CTRL020G070.012') }}</th>
            <th>{{ $t('cp.CTRL020G070.010') }}<br>{{ $t('cp.CTRL020G070.011') }}</th>
            <th>{{ $t('cp.CTRL020G070.010') }}<br>{{ $t('cp.CTRL020G070.012') }}</th>
            <th>{{ $t('cp.CTRL020G070.130') }}</th>
            <th>{{ $t('cp.CTRL020G070.013') }}</th>
            <th>{{ $t('cp.CTRL020G070.131') }}</th>
            <th>{{ $t('cp.CTRL020G070.132') }}</th>
            <th>{{ $t('cp.CTRL020G070.133') }}</th>
            <th>{{ $t('cp.CTRL020G070.014') }}</th>
            <th>{{ $t('cp.CTRL020G070.015') }}</th>
            <th>{{ $t('cp.CTRL020G070.016') }}</th>
            <th>{{ $t('cp.CTRL020G070.018') }}</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td class="chk"><input type="checkbox" name="no" id="chk1" v-model="send.keyCheck.porCtrYn" true-value="Y" false-value="" :disabled="true"><label for="chk1"><span class="offscreen">No</span></label></td>
            <td class="chk"><input type="checkbox" name="no" id="chk2" v-model="send.keyCheck.porPlcYn" true-value="Y" false-value="" :disabled="isAllShipper()"><label for="chk2"><span class="offscreen">No</span></label></td>
            <td class="chk"><input type="checkbox" name="no" id="chk3" v-model="send.keyCheck.dlyCtrYn" true-value="Y" false-value="" :disabled="true"><label for="chk3"><span class="offscreen">No</span></label></td>
            <td class="chk"><input type="checkbox" name="no" id="chk4" v-model="send.keyCheck.dlyPlcYn" true-value="Y" false-value="" :disabled="isAllShipper()"><label for="chk4"><span class="offscreen">No</span></label></td>
            <td class="chk"><input type="checkbox" name="no" id="chk11" v-model="send.keyCheck.routeYn" @change="checkInvalidCase('routeYn', 'all')" true-value="Y" false-value="" :disabled="isAllShipper()"><label for="chk11"><span class="offscreen">No</span></label></td>
            <td class="chk"><input type="checkbox" name="no" id="chk5" v-model="send.keyCheck.itemYn" @change="checkInvalidCase('itemYn', 'case1')" true-value="Y" false-value="" :disabled="isAllShipper()"><label for="chk5"><span class="offscreen">No</span></label></td>
            <td class="chk"><input type="checkbox" name="no" id="chk12" v-model="send.keyCheck.cntrSzTypYn" @change="checkInvalidCase('cntrSzTypYn', 'all')" true-value="Y" false-value="" :disabled="isAllShipper()"><label for="chk12"><span class="offscreen">No</span></label></td>
            <td class="chk"><input type="checkbox" name="no" id="chk13" v-model="send.keyCheck.frtPncYn" @change="checkInvalidCase('frtPncYn', 'all')" true-value="Y" false-value="" :disabled="isAllShipper()"><label for="chk13"><span class="offscreen">No</span></label></td>
            <td class="chk"><input type="checkbox" name="no" id="chk14" v-model="send.keyCheck.bidgCstYn" @change="checkInvalidCase('bidgCstYn', 'all')" true-value="Y" false-value="" :disabled="isAllShipper()"><label for="chk14"><span class="offscreen">No</span></label></td>
            <td class="chk"><input type="checkbox" name="no" id="chk6" v-model="send.keyCheck.bkgShipperYn" true-value="Y" false-value="" :disabled="isAllShipper()"><label for="chk6"><span class="offscreen">No</span></label></td>
            <td class="chk"><input type="checkbox" name="no" id="chk7" v-model="send.keyCheck.actShipperYn" @change="checkInvalidCase('actShipperYn', 'case1')" true-value="Y" false-value="" :disabled="isAllShipper()"><label for="chk7"><span class="offscreen">No</span></label></td>
            <td class="chk"><input type="checkbox" name="no" id="chk8" v-model="send.keyCheck.hcneShipperYn" true-value="Y" false-value="" :disabled="isAllShipper()"><label for="chk8"><span class="offscreen">No</span></label></td>
            <td class="chk"><input type="checkbox" name="no" id="chk10" v-model="send.keyCheck.profileYn" true-value="Y" false-value="" :disabled="isAllShipper()"><label for="chk10"><span class="offscreen">No</span></label></td>
          </tr>
        </tbody>
      </table>
      <table class="tbl_col mt10 cp-table-fix">
        <colgroup>
          <col width="7.69%">
          <col width="7.69%">
          <col width="7.69%">
          <col width="7.69%">
          <col width="7.69%">
          <col width="7.69%">
          <col width="7.69%">
          <col width="7.69%">
          <col width="7.69%">
          <col width="7.69%">
          <col width="7.69%">
          <col width="7.69%">
          <col width="5.72%">
          <col width="2%">
        </colgroup>
        <thead>
          <tr>
            <th>{{ $t('cp.CTRL020G070.009') }}<br>{{ $t('cp.CTRL020G070.011') }}</th>
            <th>{{ $t('cp.CTRL020G070.009') }}<br>{{ $t('cp.CTRL020G070.012') }}</th>
            <th>{{ $t('cp.CTRL020G070.010') }}<br>{{ $t('cp.CTRL020G070.011') }}</th>
            <th>{{ $t('cp.CTRL020G070.010') }}<br>{{ $t('cp.CTRL020G070.012') }}</th>
            <th>{{ $t('cp.CTRL020G070.130') }}</th>
            <th>{{ $t('cp.CTRL020G070.013') }}</th>
            <th>{{ $t('cp.CTRL020G070.131') }}</th>
            <th>{{ $t('cp.CTRL020G070.132') }}</th>
            <th>{{ $t('cp.CTRL020G070.133') }}</th>
            <th>{{ $t('cp.CTRL020G070.014') }}</th>
            <th>{{ $t('cp.CTRL020G070.015') }}</th>
            <th>{{ $t('cp.CTRL020G070.016') }}</th>
            <th>{{ $t('cp.CTRL020G070.018') }}</th>
            <th><button class="tbl_icon plus" :class="{'disabled': isAllShipper()}" @click.prevent="addRows()" :disabled="isAllShipper()">plus</button></th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(kIitem, kIidx) in send.keyInput" :key="kIidx">
            <td class="cp-relative">
              <input
                :id="`porCtrPsel${kIidx}`"
                class="cp-psel"
                @mousedown.stop="clickPsel(kIidx, 'porCtr')"
                :placeholder="setPselTxt(kIidx, 'porCtr')"
                :disabled="isAllShipper()"
                readonly
              >
              <div
                :id="`porCtrPopt${kIidx}`"
                class="cp-unitbox cp-popt cp-popt--close"
                @mousedown.stop
              >
                <div class="cp-li-header flex_box">
                  <input :id="`porCtrPopt${kIidx}Search`" type="text" v-model="poptSearchKeyword" :placeholder="$t('cp.COMMON.001')">
                </div>
                <ul class="cp-scroll cp-ul cp-ul--ctr cp-ul--hide">
                  <li class="cp-li">{{ setLongestText(kIidx, 'porCtr') }}</li>
                </ul>
                <ul class="cp-scroll cp-ul cp-ul--ctr">
                  <li
                    v-for="(item, idx) in countryListForEntry"
                    :key="idx"
                    :value="item.ctrCd"
                    class="cp-li"
                    :class="{
                      'cp-li--selected': kIitem.porCtr === item.ctrCd,
                      'cp-li--hide': searchPopt(item.ctrEnm, item.ctrCd)
                    }"
                    @click="clickPopt(kIidx, 'porCtr', item.ctrCd)"
                  >
                    <span>{{ item.ctrEnm }}</span>
                  </li>
                </ul>
              </div>
            </td>
            <td class="cp-relative">
              <input
                :id="`porPlcPsel${kIidx}`"
                class="cp-psel"
                @mousedown.stop="clickPsel(kIidx, 'porPlc')"
                :placeholder="setPselTxt(kIidx, 'porPlc')"
                :disabled="isAllShipper()"
                readonly
              >
              <div
                :id="`porPlcPopt${kIidx}`"
                class="cp-unitbox cp-popt cp-popt--close"
                @mousedown.stop
              >
                <div class="cp-li-header flex_box">
                  <input type="checkbox" name="no">
                  <label
                    :class="{
                      'cp-pchkbox--disabled': kIitem.porHarborList?.length === 0,
                      'cp-pchkbox--hide': poptSearchKeyword !== '',
                      'cp-pchkbox--selected': kIitem.porHarborList?.length !== 0 && (kIitem.porHarborList.length === kIitem.porPlc.length)
                    }"
                    @click.prevent="controlPchk(kIidx, 'porPlc')"
                  >
                    <span class="offscreen">No</span>
                  </label>
                  <input :id="`porPlcPopt${kIidx}Search`" type="text" v-model="poptSearchKeyword" :placeholder="$t('cp.COMMON.001')" :disabled="kIitem.porHarborList?.length === 0">
                </div>
                <ul v-if="kIitem.porHarborList?.length !== 0" class="cp-scroll cp-ul cp-ul--plc cp-ul--hide">
                  <li class="cp-li">
                    <input type="checkbox" name="no">
                    <label><span class="offscreen">No</span></label>
                    <span>{{ setLongestText(kIidx, 'porPlc') }}</span>
                  </li>
                </ul>
                <ul class="cp-scroll cp-ul cp-ul--plc">
                  <li
                    v-for="(item, idx) in kIitem.porHarborList"
                    :key="idx"
                    :value="idx"
                    class="cp-li"
                    :class="{
                      'cp-li--selected': kIitem.porPlc.includes(item.plcCd),
                      'cp-li--hide': searchPopt(item.plcNm, item.plcCd)
                    }"
                    @click.prevent="clickPopt(kIidx, 'porPlc', item.plcCd)"
                  >
                    <input type="checkbox" name="no">
                    <label :class="{'cp-pchkbox--selected': kIitem.porPlc.includes(item.plcCd)}"><span class="offscreen">No</span></label>
                    <span>{{ item.plcNm }}</span>
                  </li>
                </ul>
              </div>
            </td>
            <td class="cp-relative">
              <input
                :id="`dlyCtrPsel${kIidx}`"
                class="cp-psel"
                @mousedown.stop="clickPsel(kIidx, 'dlyCtr')"
                :placeholder="setPselTxt(kIidx, 'dlyCtr')"
                :disabled="isAllShipper()"
                readonly
              >
              <div
                :id="`dlyCtrPopt${kIidx}`"
                class="cp-unitbox cp-popt cp-popt--close"
                @mousedown.stop
              >
                <div class="cp-li-header flex_box">
                  <input :id="`dlyCtrPopt${kIidx}Search`" type="text" v-model="poptSearchKeyword" :placeholder="$t('cp.COMMON.001')">
                </div>
                <ul class="cp-scroll cp-ul cp-ul--ctr cp-ul--hide">
                  <li class="cp-li">{{ setLongestText(kIidx, 'dlyCtr') }}</li>
                </ul>
                <ul class="cp-scroll cp-ul cp-ul--ctr">
                  <li
                    v-for="(item, idx) in countryListForEntry"
                    :key="idx"
                    :value="item.ctrCd"
                    class="cp-li"
                    :class="{
                      'cp-li--selected': kIitem.dlyCtr === item.ctrCd,
                      'cp-li--hide': searchPopt(item.ctrEnm, item.ctrCd)
                    }"
                    @click="clickPopt(kIidx, 'dlyCtr', item.ctrCd)"
                  >
                    <span>{{ item.ctrEnm }}</span>
                  </li>
                </ul>
              </div>
            </td>
            <td class="cp-relative">
              <input
                :id="`dlyPlcPsel${kIidx}`"
                class="cp-psel"
                @mousedown.stop="clickPsel(kIidx, 'dlyPlc')"
                :placeholder="setPselTxt(kIidx, 'dlyPlc')"
                :disabled="isAllShipper()"
                readonly
              >
              <div
                :id="`dlyPlcPopt${kIidx}`"
                class="cp-unitbox cp-popt cp-popt--close"
                @mousedown.stop
              >
                <div class="cp-li-header flex_box">
                  <input type="checkbox" name="no">
                  <label
                    :class="{
                      'cp-pchkbox--disabled': kIitem.dlyHarborList?.length === 0,
                      'cp-pchkbox--hide': poptSearchKeyword !== '',
                      'cp-pchkbox--selected': kIitem.dlyHarborList?.length !== 0 && (kIitem.dlyHarborList.length === kIitem.dlyPlc.length)
                    }"
                    @click.prevent="controlPchk(kIidx, 'dlyPlc')"
                  >
                    <span class="offscreen">No</span>
                  </label>
                  <input :id="`dlyPlcPopt${kIidx}Search`" type="text" v-model="poptSearchKeyword" :placeholder="$t('cp.COMMON.001')" :disabled="kIitem.dlyHarborList?.length === 0">
                </div>
                <ul v-if="kIitem.dlyHarborList?.length !== 0" class="cp-scroll cp-ul cp-ul--plc cp-ul--hide">
                  <li class="cp-li">
                    <input type="checkbox" name="no">
                    <label><span class="offscreen">No</span></label>
                    <span>{{ setLongestText(kIidx, 'dlyPlc') }}</span>
                  </li>
                </ul>
                <ul class="cp-scroll cp-ul cp-ul--plc">
                  <li
                    v-for="(item, idx) in kIitem.dlyHarborList"
                    :key="idx"
                    :value="idx"
                    class="cp-li"
                    :class="{
                      'cp-li--selected': kIitem.dlyPlc.includes(item.plcCd),
                      'cp-li--hide': searchPopt(item.plcNm, item.plcCd)
                    }"
                    @click.prevent="clickPopt(kIidx, 'dlyPlc', item.plcCd)"
                  >
                    <input type="checkbox" name="no">
                    <label :class="{'cp-pchkbox--selected': kIitem.dlyPlc.includes(item.plcCd)}"><span class="offscreen">No</span></label>
                    <span>{{ item.plcNm }}</span>
                  </li>
                </ul>
              </div>
            </td>
            <td class="cp-relative">
              <input
                :id="`routePsel${kIidx}`"
                class="cp-psel"
                @mousedown.stop="clickPsel(kIidx, 'route')"
                :placeholder="setPselTxt(kIidx, 'route')"
                :disabled="isAllShipper()"
                readonly
              >
              <div
                :id="`routePopt${kIidx}`"
                class="cp-unitbox cp-popt cp-popt--close"
                @mousedown.stop
              >
                <div class="cp-li-header flex_box">
                  <input type="checkbox" name="no">
                  <label
                    :class="{
                      'cp-pchkbox--disabled': routeList?.length === 0,
                      'cp-pchkbox--hide': poptSearchKeyword !== '',
                      'cp-pchkbox--selected': kIitem.route?.length !== 0 && (routeList.length === kIitem.route.length)
                    }"
                    @click.prevent="controlPchk(kIidx, 'route')"
                  >
                    <span class="offscreen">No</span>
                  </label>
                  <input :id="`routePopt${kIidx}Search`" type="text" v-model="poptSearchKeyword" :placeholder="$t('cp.COMMON.001')" :disabled="routeList?.length === 0">
                </div>
                <ul v-if="routeList?.length !== 0" class="cp-scroll cp-ul cp-ul--plc cp-ul--hide">
                  <li class="cp-li">
                    <input type="checkbox" name="no">
                    <label><span class="offscreen">No</span></label>
                    <span>{{ setLongestText(kIidx, 'route') }}</span>
                  </li>
                </ul>
                <ul class="cp-scroll cp-ul cp-ul--plc">
                  <li
                    v-for="(rteCd, idx) in routeList"
                    :key="idx"
                    :value="idx"
                    class="cp-li"
                    :class="{
                      'cp-li--selected': kIitem.route.includes(rteCd),
                      'cp-li--hide': searchPopt(rteCd, rteCd)
                    }"
                    @click.prevent="clickPopt(kIidx, 'route', rteCd)"
                  >
                    <input type="checkbox" name="no">
                    <label :class="{'cp-pchkbox--selected': kIitem.route.includes(rteCd)}"><span class="offscreen">No</span></label>
                    <span>{{ rteCd }}</span>
                  </li>
                </ul>
              </div>
            </td>
            <td>
              <a href="#" @click.prevent="openPopup('ItemListPop', 'item', kIidx)" class="button sm cp-td-button" :class="{'disabled': isAllShipper()}" :disabled="isAllShipper()">
                <template v-if="kIitem.itemLength === 0 || kIitem.itemLength === undefined">
                  {{ $t('cp.COMMON.002') }}
                </template>
                <template v-else-if="kIitem.itemLength === 1">
                  <span class="cp-short-text">{{ kIitem.lastItem }}</span>
                </template>
                <template v-else>
                  <span class="cp-short-text">({{ kIitem.itemLength }}) {{ kIitem.lastItem }}</span>
                </template>
              </a>
            </td>
            <td>
              <a href="#" @click.prevent="openPopup('cntrSzTypListPop', 'cntrSzTyp', kIidx)" class="button sm cp-td-button" :class="{'disabled': isAllShipper()}" :disabled="isAllShipper()">
                <template v-if="kIitem.cntrSzTypLength === 0 || kIitem.cntrSzTypLength === undefined">
                  {{ $t('cp.COMMON.002') }}
                </template>
                <template v-else-if="kIitem.cntrSzTypLength === 1">
                  <span class="cp-short-text">{{ kIitem.lastCntrSzTyp }}</span>
                </template>
                <template v-else>
                  <span class="cp-short-text">({{ kIitem.cntrSzTypLength }}) {{ kIitem.lastCntrSzTyp }}</span>
                </template>
              </a>
            </td>
            <td>
              <select v-model="kIitem.frtPnc" :disabled="isAllShipper()" @change="kIitem.frtPnc !== '' ? setKeyCheck('frtPnc') : {}">
                <option value="" selected>{{ $t('cp.COMMON.002') }}</option>
                <option v-for="(item, idx) in frtPncList" :key="idx" :value="item.detailCd">{{ item.detailNm }}</option>
              </select>
            </td>
            <td>
              <select v-model="kIitem.bidgCst" :disabled="isAllShipper()" @change="kIitem.frtPnc !== '' ? setKeyCheck('bidgCst') : {}">
                <option value="" selected>{{ $t('cp.COMMON.002') }}</option>
                <option v-for="(item, idx) in bidgCstList" :key="idx" :value="item.detailCd">{{ item.detailNm }}</option>
              </select>
            </td>
            <td>
              <div class="tbl_form cp-relative">
                <a href="#" @click.prevent="openPopup('CstSearchListPop', 'bkgShipper', kIidx)" class="button sm cp-td-button" :class="{'disabled': isAllShipper()}" :disabled="isAllShipper()">
                  <template v-if="kIitem.bkgShipLength === 0 || kIitem.bkgShipLength === undefined">
                    {{ $t('cp.COMMON.002') }}
                  </template>
                  <template v-else-if="kIitem.bkgShipLength === 1">
                    <span class="cp-short-text">{{ kIitem.lastBkgShip }}</span>
                  </template>
                  <template v-else>
                    <span class="cp-short-text">({{ kIitem.bkgShipLength }}) {{ kIitem.lastBkgShip }}</span>
                  </template>
                </a>
              </div>
            </td>
            <td>
              <div class="tbl_form">
                <a href="#" @click.prevent="openPopup('CstSearchListPop', 'actShipper', kIidx)" class="button sm cp-td-button" :class="{'disabled': isAllShipper()}" :disabled="isAllShipper()">
                  <template v-if="kIitem.actShipLength === 0 || kIitem.actShipLength === undefined">
                    {{ $t('cp.COMMON.002') }}
                  </template>
                  <template v-else-if="kIitem.actShipLength === 1">
                    <span class="cp-short-text">{{ kIitem.lastActShip }}</span>
                  </template>
                  <template v-else>
                    <span class="cp-short-text">({{ kIitem.actShipLength }}) {{ kIitem.lastActShip }}</span>
                  </template>
                </a>
              </div>
            </td>
            <td>
              <div class="tbl_form">
                <a href="#" @click.prevent="openPopup('CstSearchListPop', 'hcneShipper', kIidx)" class="button sm cp-td-button" :class="{'disabled': isAllShipper()}" :disabled="isAllShipper()">
                  <template v-if="kIitem.hcneShipLength === 0 || kIitem.hcneShipLength === undefined">
                    {{ $t('cp.COMMON.002') }}
                  </template>
                  <template v-else-if="kIitem.hcneShipLength === 1">
                    <span class="cp-short-text">{{ kIitem.lastHcneShip }}</span>
                  </template>
                  <template v-else>
                    <span class="cp-short-text">({{ kIitem.hcneShipLength }}) {{ kIitem.lastHcneShip }}</span>
                  </template>
                </a>
              </div>
            </td>
            <td>
              <div class="tbl_form">
                <a href="#" @click.prevent="openPopup('ProfileListPop', 'profile', kIidx)" class="button sm cp-td-button" :class="{'disabled': isAllShipper()}" :disabled="isAllShipper()">
                  <template v-if="kIitem.profileLength === 0 || kIitem.profileLength === undefined">
                    {{ $t('cp.COMMON.002') }}
                  </template>
                  <template v-else-if="kIitem.profileLength === 1">
                    <span class="cp-short-text">{{ kIitem.lastProfile }}</span>
                  </template>
                  <template v-else>
                    <span class="cp-short-text">({{ kIitem.profileLength }}) {{ kIitem.lastProfile }}</span>
                  </template>
                </a>
              </div>
            </td>
            <td><button class="tbl_icon minus" :class="{'disabled': isAllShipper()}" @click.prevent="removeRows(kIidx)" :disabled="isAllShipper()">minus</button></td>
          </tr>
        </tbody>
      </table>
    </div>
    <div class="content_box mt10">
      <div v-for="(cond, condIdx) in send.condList" :key="condIdx">
        <template v-if="condIdx === 0">
          <div class="flex_box mb5">
            <h2 class="content_title">{{ $t('cp.CTRL020G070.019') }}{{ condIdx + 1 }}</h2>
            <span class="ml_auto cal_btn">
              <a href="#" @click.prevent="asyncAlert($t('cp.CTRL020G070.143'), 'reset')" class="button sm blue" :class="{'disabled': isAllShipper()}" :disabled="isAllShipper()">{{ $t('cp.CTRL020G070.142') }}</a>
            </span>
          </div>
        </template>
        <template v-else>
          <div class="cp-logicoper cp-logicoper--or mt30">OR</div>
          <div class="flex_box mb5">
            <h2 class="content_title">{{ $t('cp.CTRL020G070.019') }}{{ condIdx + 1 }}</h2>
            <span class="ml_auto cal_btn">
              <a href="#" @click.prevent="removeCond(condIdx)" class="button sm" :class="{'disabled': isAllShipper()}" :disabled="isAllShipper()">{{ $t('cp.CTRL020G070.020') }}</a>
            </span>
          </div>
        </template>
        <table class="tbl_col">
          <colgroup>
            <col width="18%"> <!-- 팩터선택 -->
            <col width="9%">  <!-- 기간옵션 -->
            <col width="5%">  <!-- Update Date -->
            <col width="8%">  <!-- From -->
            <col width="8%">  <!-- To -->
            <col width="8%">  <!-- 회원등급 -->
            <col width="10%"> <!-- 비교기호 -->
            <col width="15%"> <!-- 팩터선택 -->
            <col width="9%">  <!-- 기간옵션 -->
            <col width="8%">  <!-- From -->
            <col width="8%">  <!-- To -->
            <col width="2%">  <!-- Row 추가/삭제 -->
          </colgroup>
          <thead>
            <tr>
              <th>{{ $t('cp.CTRL020G070.021') }}</th> <!-- 팩터선택 -->
              <th>{{ $t('cp.CTRL020G070.022') }}</th> <!-- 기간옵션 -->
              <th v-if="condIdx === 0">
                <!-- Update Date -->
                <div>
                  <span v-html="$t('cp.CTRL020G070.023').replace('\n', '<br>')"></span>&nbsp;
                  <span class="position_relative">
                    <button type="button" class="tbl_icon help" @click="isShowHelp2 = !isShowHelp2">help</button>
                    <div v-show="isShowHelp2" class="tooltip_wrap short position_absolute" style="min-width:200px; left:0; top:24px;">
                      <div class="cont">
                        <button type="button" class="close" @click="isShowHelp2 = false">close</button>
                        <ul class="bul_list_sm t2" style="white-space: nowrap">
                          <li>
                            <p v-for="(line, idx) in $t('cp.CTRL020G070.024').split('\n')" :key="idx">
                              {{ line }}
                            </p>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </span>
                </div>
              </th>
              <th v-else><span v-html="$t('cp.CTRL020G070.023').replace('&nbsp;', '').replace('\n', '<br>')"></span></th> <!-- From -->
              <th>{{ $t('cp.CTRL020G070.025') }}</th> <!-- From -->
              <th>{{ $t('cp.CTRL020G070.026') }}</th> <!-- To   -->
              <th>{{ $t('cp.CTRL020G070.168') }}</th> <!-- 화주등급 -->
              <th>{{ $t('cp.CTRL020G070.027') }}</th> <!-- 비교기호 -->
              <th>{{ $t('cp.CTRL020G070.028') }}</th> <!-- 팩터선택 -->
              <th>{{ $t('cp.CTRL020G070.022') }}</th> <!-- 기간옵션 -->
              <th>{{ $t('cp.CTRL020G070.025') }}</th> <!-- From -->
              <th>{{ $t('cp.CTRL020G070.026') }}</th> <!-- To -->
              <th><button class="tbl_icon plus" :class="{'disabled': isAllShipper()}" @click.prevent="addCondRows(condIdx)" :disabled="isAllShipper()">plus</button></th> <!-- Row 추가/삭제 -->
            </tr>
          </thead>
          <tbody>
            <tr v-for="(condRow, condRowIdx ) in cond" :key="condRowIdx ">
              <td>
                <div class="tbl_form">
                  <span class="dv cp-parentnode">
                    <span class="cp-flex">
                      <span :style="{ visibility: condRowIdx !== 0 ? 'visible' : 'hidden' }" class="cp-logicoper cp-logicoper--and">AND</span>
                      <input type="text" v-model="condRow.factorNm" readonly :disabled="isAllShipper()">
                    </span>
                  </span>
                  <span class="dv wid20">
                    <button class="tbl_icon search" @click.prevent="openPopup('FactorListPop', `L-${condRow.andor}`, condRowIdx )" :disabled="isAllShipper()">Search</button>
                  </span>
                  <span class="dv wid25" v-show="condRow.inputUseYn === 'Y'"><input type="text" v-model="condRow.factorOpt1" style="padding:0 2px;" :disabled="isAllShipper()"></span>
                  <span class="dv wid25" v-show="condRow.inputUseYn === 'Y'"><input type="text" v-model="condRow.factorOpt2" style="padding:0 2px;" :disabled="isAllShipper()"></span>
                </div>
              </td>
              <td>
                <select v-model="condRow.periodDiv" :disabled="isAllShipper() || condRow.periodUseYn === '' || condRow.periodUseYn === 'N'">
                  <option value="">{{ $t('cp.COMMON.002') }}</option>
                  <option v-for="(item, idx) in eachPeriodGbnList[condRow.factorCd]" :key="idx" :value="item.detailCd">{{ item.detailNm }}</option>
                </select>
              </td>
              <td>
                <span class="dv">
                  <input type="checkbox" :id="`condUpdatePeriod-${condIdx}-${condRowIdx}`" v-model="condRow.updatePeriodYn" true-value="Y" false-value="" :disabled="isAllShipper()"><label :for="`condUpdatePeriod-${condIdx}-${condRowIdx}`"><span class="offscreen">No</span></label>
                </span>
              </td>
              <td>
                <div class="input_calendar short">
                  <e-date-picker v-model="condRow.periodFr" style="width:100px" @input="validateDate(condRow, 'F')" :disabled="isAllShipper() || condRow.periodUseYn === '' || condRow.periodUseYn === 'N'" />
                </div>
              </td>
              <td>
                <div class="input_calendar short">
                  <e-date-picker v-model="condRow.periodTo" style="width:100px" @input="validateDate(condRow, 'T')" :disabled="isAllShipper() || condRow.periodUseYn === '' || condRow.periodUseYn === 'N'" />
                </div>
              </td>
              <td>
                <!--                <select v-model="condRow.cstGrd" :disabled="condRowIdx === 0 ? isAllShipper() ? true : false : true">-->
                <select v-model="condRow.cstGrd" :disabled="true">
                  <option value="">{{ $t('cp.COMMON.015') }}</option>
                  <option value="A">A</option>
                  <option value="B">B</option>
                  <option value="C">C</option>
                  <option value="D">D</option>
                </select>
              </td>
              <td>
                <div class="tbl_form">
                  <select
                    v-model="condRow.equlSign"
                    class="mr5"
                    @change="[equalSignEvt(condRow)]"
                    :disabled="isAllShipper()"
                  >
                    <option value="">{{ $t('cp.COMMON.002') }}</option>
                    <option
                      v-for="(item, idx) in equalSignList.filter(elem => condRow.tbIdYn === 'Y' ? elem : elem.type === 'SI' )" :key="idx"
                      :value="item.detailCd"
                    >
                      {{ item.detailNm }}
                    </option>
                  </select>
                  <span v-if="['TB', 'ID'].includes(getEqualSignType(condRow.equlSign))" class="dv position_relative">
                    <button
                      type="button" class="tbl_icon help help--cp ml5"
                      @click="cpIsShowHelp = (cpIsShowHelp !== `${condIdx}-${condRowIdx}` ? `${condIdx}-${condRowIdx}` : '')"
                    >
                      help
                    </button>
                    <div v-show="cpIsShowHelp === `${condIdx}-${condRowIdx}`" class="tooltip_wrap short position_absolute" style="min-width:200px; left:5px; top:24px;">
                      <div class="cont">
                        <button type="button" class="close" @click="cpIsShowHelp = ''">close</button>
                        <ul class="bul_list_sm t2" style="white-space: nowrap">
                          <li>
                            <p v-for="(line, idx) in cpShowHelpText[condRow.equlSign].split('\n')" :key="idx">
                              {{ line }}
                            </p>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </span>
                </div>
                <div v-if="getEqualSignType(condRow.equlSign) === 'ID'" class="tbl_form mt5">
                  <span class="dv">
                    <input
                      type="number" :id="`compareOpt${condIdx}-${condRowIdx}`"
                      v-model="condRow.compareOpt1"
                      @keydown.69.prevent @keydown.up.prevent @keydown.down.prevent
                      :disabled="isAllShipper()"
                    >
                  </span>
                  <span class="dv wid45">
                    <select v-model="condRow.compareOpt2">
                      <option value="N">N</option>
                      <option value="%">%</option>
                    </select>
                  </span>
                  <span class="dv wid45">
                    <select v-model="condRow.compareOpt3" style="font-weight: bold">
                      <option value="↑">↑</option>
                      <option value="↓">↓</option>
                    </select>
                  </span>
                </div>
              </td>
              <td>
                <div v-if="getEqualSignType(condRow.equlSign) !== 'TB'" class="tbl_form">
                  <span class="dv">
                    <input type="text" :id="`condFactorCdC-${condIdx}-${condRowIdx}`" v-model="condRow.factorNmC" readonly @input="condRow.factorCdC = condRow.factorNmC" @change="[condRow.factorCdC = condRow.factorNmC, condRow.compareOpt1 = '']" @keyup="condRow.factorCdC = condRow.factorNmC" :disabled="isAllShipper()">
                  </span>
                  <span class="dv wid20">
                    <button class="tbl_icon search" @click.prevent="openPopup('FactorListPop', `R-${condRow.andor}`, condRowIdx )" :disabled="isAllShipper()">Search</button>
                  </span>
                  <span class="dv wid25" v-show="condRow.inputUseYnC === 'Y'"><input type="text" v-model="condRow.factorOpt1C" style="padding:0 2px;" :disabled="isAllShipper()"></span>
                  <span class="dv wid25" v-show="condRow.inputUseYnC === 'Y'"><input type="text" v-model="condRow.factorOpt2C" style="padding:0 2px;" :disabled="isAllShipper()"></span>
                </div>
                <div v-else class="tbl_form">
                  <span class="dv">
                    <input
                      type="number" :id="`compareOpt${condIdx}-${condRowIdx}`"
                      v-model="condRow.compareOpt1"
                      @change="condRow.factorNmC = ''"
                      @keydown.69.prevent @keydown.up.prevent @keydown.down.prevent
                      :disabled="isAllShipper()"
                    >
                  </span>
                  <span class="dv wid45">
                    <select v-model="condRow.compareOpt2">
                      <option value="N">N</option>
                      <option value="%">%</option>
                    </select>
                  </span>
                </div>
              </td>
              <td>
                <select v-model="condRow.periodDivC" :disabled="isAllShipper() || condRow.periodUseYnC === '' || condRow.periodUseYnC === 'N'">
                  <option value="">{{ $t('cp.COMMON.002') }}</option>
                  <option v-for="(item, idx) in eachPeriodGbnList[condRow.factorCdC]" :key="idx" :value="item.detailCd">{{ item.detailNm }}</option>
                </select>
              </td>
              <td>
                <div class="input_calendar short">
                  <e-date-picker v-model="condRow.periodFrC" style="width:100px" :disabled="isAllShipper() || condRow.periodUseYnC === '' || condRow.periodUseYnC === 'N'" />
                </div>
              </td>
              <td>
                <div class="input_calendar short">
                  <e-date-picker v-model="condRow.periodToC" style="width:100px" :disabled="isAllShipper() || condRow.periodUseYnC === '' || condRow.periodUseYnC === 'N'" />
                </div>
              </td>
              <td><button class="tbl_icon minus" :class="{'disabled': isAllShipper()}" @click.prevent="removeCondRows(condIdx, condRowIdx)" :disabled="isAllShipper()">minus</button></td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="flex_box mt30">
        <table class="tbl_col">
          <thead>
            <tr>
              <th>
                <div class="cp-th-button" :class="{'disabled': isAllShipper()}" @click.prevent="addCond">
                  <button class="tbl_icon plus" :class="{'disabled': isAllShipper()}" :disabled="isAllShipper()">plus</button>
                  <div>{{ $t('cp.CTRL020G070.029') }}</div>
                </div>
              </th>
            </tr>
          </thead>
        </table>
      </div>
      <div class="flex_box mt8">
        <a class="button lg blue ml_auto" :class="{'disabled': isAllShipper()}" href="#" @click.prevent="entryValid()" :disabled="isAllShipper()">{{ $t('cp.CTRL020G070.088') }}</a>
      </div>
    </div>
    <div class="content_box mt10">
      <div class="flex_box mb15 cp-parentnode">
        <h2 class="content_title">{{ $t('cp.CTRL020G070.030') }}</h2>
        <span class="ml_auto cal_btn">
          <a href="#" @click.prevent="getTargetFactorInfo" class="button lg blue mr5">{{ $t('cp.CTRL020G070.154') }}</a><!-- 타겟 팩터 계산 -->
          <a href="#" @click.prevent="openPopup('TargetCondApplyPop', 'targetCondApply')" class="button lg blue" :class="{disabled: !(targetConfirmed || (groupKeyCheck.afterEntry === 'Y' && gridList.length !== 0))}">{{ $t('cp.CTRL020G070.144') }}</a>
        </span>
      </div>
      <table class="tbl_col">
        <colgroup>
          <col width="7.69%">
          <col width="7.69%">
          <col width="7.69%">
          <col width="7.69%">
          <col width="7.69%">
          <col width="7.69%">
          <col width="7.69%">
          <col width="7.69%">
          <col width="7.69%">
          <col width="7.69%">
          <col width="7.69%">
          <col width="7.69%">
          <col width="7.72%">
        </colgroup>
        <thead>
          <tr>
            <th>{{ $t('cp.CTRL020G070.009') }}<br>{{ $t('cp.CTRL020G070.011') }}</th>
            <th>{{ $t('cp.CTRL020G070.009') }}<br>{{ $t('cp.CTRL020G070.012') }}</th>
            <th>{{ $t('cp.CTRL020G070.010') }}<br>{{ $t('cp.CTRL020G070.011') }}</th>
            <th>{{ $t('cp.CTRL020G070.010') }}<br>{{ $t('cp.CTRL020G070.012') }}</th>
            <th>{{ $t('cp.CTRL020G070.130') }}</th>
            <th>{{ $t('cp.CTRL020G070.013') }}</th>
            <th>{{ $t('cp.CTRL020G070.131') }}</th>
            <th>{{ $t('cp.CTRL020G070.132') }}</th>
            <th>{{ $t('cp.CTRL020G070.133') }}</th>
            <th>{{ $t('cp.CTRL020G070.014') }}</th>
            <th>{{ $t('cp.CTRL020G070.015') }}</th>
            <th>{{ $t('cp.CTRL020G070.016') }}</th>
            <th>{{ $t('cp.CTRL020G070.018') }}</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td class="chk">
              <input type="checkbox" name="grno" id="grchk1" v-model="groupKeyCheck.porCtrYn" true-value="Y" false-value="" @change="groupBy('')" :disabled="isAllShipper()"><label for="grchk1"><span class="offscreen">No</span></label>
            </td>
            <td class="chk">
              <input type="checkbox" name="grno" id="grchk2" v-model="groupKeyCheck.porPlcYn" true-value="Y" false-value="" @change="groupBy('')" :disabled="isAllShipper()"><label for="grchk2"><span class="offscreen">No</span></label>
            </td>
            <td class="chk">
              <input type="checkbox" name="grno" id="grchk3" v-model="groupKeyCheck.dlyCtrYn" true-value="Y" false-value="" @change="groupBy('')" :disabled="isAllShipper()"><label for="grchk3"><span class="offscreen">No</span></label>
            </td>
            <td class="chk">
              <input type="checkbox" name="grno" id="grchk4" v-model="groupKeyCheck.dlyPlcYn" true-value="Y" false-value="" @change="groupBy('')" :disabled="isAllShipper()"><label for="grchk4"><span class="offscreen">No</span></label>
            </td>
            <td class="chk">
              <input type="checkbox" name="grno" id="grchk11" v-model="groupKeyCheck.routeYn" true-value="Y" false-value="" @change="groupBy('')" :disabled="isAllShipper()"><label for="grchk11"><span class="offscreen">No</span></label>
            </td>
            <td class="chk">
              <input type="checkbox" name="grno" id="grchk5" v-model="groupKeyCheck.itemYn" true-value="Y" false-value="" @change="groupBy('')" :disabled="isAllShipper()"><label for="grchk5"><span class="offscreen">No</span></label>
            </td>
            <td class="chk">
              <input type="checkbox" name="grno" id="grchk12" v-model="groupKeyCheck.cntrSzTypYn" true-value="Y" false-value="" @change="groupBy('')" :disabled="isAllShipper()"><label for="grchk12"><span class="offscreen">No</span></label>
            </td>
            <td class="chk">
              <input type="checkbox" name="grno" id="grchk13" v-model="groupKeyCheck.frtPncYn" true-value="Y" false-value="" @change="groupBy('')" :disabled="isAllShipper()"><label for="grchk13"><span class="offscreen">No</span></label>
            </td>
            <td class="chk">
              <input type="checkbox" name="grno" id="grchk14" v-model="groupKeyCheck.bidgCstYn" true-value="Y" false-value="" @change="groupBy('')" :disabled="isAllShipper()"><label for="grchk14"><span class="offscreen">No</span></label>
            </td>
            <td class="chk">
              <input type="checkbox" name="grno" id="grchk6" v-model="groupKeyCheck.bkgShipperYn" true-value="Y" false-value="" @change="groupBy('')" :disabled="isAllShipper()"><label for="grchk6"><span class="offscreen">No</span></label>
            </td>
            <td class="chk">
              <input type="checkbox" name="grno" id="grchk7" v-model="groupKeyCheck.actShipperYn" true-value="Y" false-value="" @change="groupBy('')" :disabled="isAllShipper()"><label for="grchk7"><span class="offscreen">No</span></label>
            </td>
            <td class="chk">
              <input type="checkbox" name="grno" id="grchk8" v-model="groupKeyCheck.hcneShipperYn" true-value="Y" false-value="" @change="groupBy('')" :disabled="isAllShipper()"><label for="grchk8"><span class="offscreen">No</span></label>
            </td>
            <td class="chk">
              <input type="checkbox" name="grno" id="grchk10" v-model="groupKeyCheck.profileYn" true-value="Y" false-value="" @change="groupBy('')" :disabled="isAllShipper()"><label for="grchk10"><span class="offscreen">No</span></label>
            </td>
          </tr>
        </tbody>
      </table>
      <div class="cp-parentnode cp-relative">
        <div
          class="cp-unitbox cp-realfiltering"
          :style="{
            top: `${realfiltering.pos.top}px`,
            left: `${realfiltering.pos.left}px`,
          }"
        >
          <div class="cp-pth" @click.prevent="dropdownRF('header')">
            {{ $t('cp.CTRL020G070.038') }}
          </div>
          <div
            class="cp-li-header cp-li-header--condition flex_box"
            @click.prevent="realfiltering.condFilterList.length !== 0 ? dropdownRF('toggleList') : dropdownRF('plusBtn')"
          >
            <input type="checkbox" name="no">
            <label
              :class="{
                'cp-pchkbox--selected': realfiltering.condFilterList.filter(elem => elem.active).length > 0,
                'cp-pchkbox--disabled': realfiltering.condFilterList.length === 0
              }"
              @click.prevent.stop="realfiltering.condFilterList.filter(elem => elem.active).length === 0 ? dropdownRF('plusBtn') : controlPchk(0, 'condFilter') "
            >
              <span class="offscreen">No</span>
            </label>
            <span>{{ realfiltering.valueType.charAt(0).toUpperCase() + realfiltering.valueType.slice(1) }} {{ $t('cp.CTRL020G070.039') }}</span>
            <button class="tbl_icon ml_auto plus" @click.stop="dropdownRF('plusBtn')">plus</button>
          </div>
          <div
            class="cp-dropdown"
            :class="{'cp-dropdown--close': !realfiltering.dropdownInfo.layer1}"
            :style="{'max-height': `${105 + 3 + (realfiltering.condFilterList.length > 5 ? 4 * 30 : realfiltering.condFilterList.length * 30)}px`}"
          >
            <div
              class="cp-grid"
              :class="`cp-grid--type${realfiltering.customCond.condType}`"
            >
              <span class="cp-relative">
                <input
                  id="rfPsel0"
                  class="cp-psel"
                  @mousedown.stop="clickPsel(0, 'rf')"
                  :placeholder="setPselTxt(0, 'rf')"
                  readonly
                >
                <div
                  id="rfPopt0"
                  class="cp-unitbox cp-popt cp-popt--close"
                  @mousedown.stop
                >
                  <ul class="cp-scroll cp-ul">
                    <li
                      v-for="(item, idx) in equalSignListRF[realfiltering.valueType]" :key="idx"
                      class="cp-li"
                      :class="{
                        'cp-li--selected': item.sign === realfiltering.customCond.sign,
                        'cp-li--dummy': item.sign === '-'
                      }"
                      @click.prevent="clickPopt(0, 'rf', [item.sign, item.condType])"
                    >
                      <span v-if="item.sign !== '-'">{{ item.comment }}</span>
                      <hr v-else class="cp-hr">
                    </li>
                  </ul>
                </div>
              </span>
              <input
                v-if="realfiltering.valueType === 'number'"
                type="number"
                id="rfValA"
                v-model="realfiltering.customCond.valA"
                :disabled="!realfiltering.customCond.sign"
                @keydown.enter.prevent="addFilter(realfiltering.columnName)"
                @keydown.69.prevent
                @keydown.up.prevent
                @keydown.down.prevent
              >
              <input
                v-else
                type="text"
                id="rfValA"
                v-model="realfiltering.customCond.valA"
                :disabled="!realfiltering.customCond.sign"
                @keydown.enter.prevent="addFilter(realfiltering.columnName)"
              >
              <template v-if="realfiltering.customCond.condType === 'B'">
                <span class="cp-logicoper cp-logicoper--and">AND</span>
                <input
                  type="number"
                  id="rfValB"
                  v-model="realfiltering.customCond.valB"
                  :disabled="!realfiltering.customCond.sign"
                  @keydown.enter.prevent="addFilter(realfiltering.columnName)"
                  @keydown.69.prevent
                  @keydown.up.prevent
                  @keydown.down.prevent
                >
              </template>
              <template v-else-if="realfiltering.customCond.condType === 'P'">
                <select v-model="realfiltering.customCond.isConst">
                  <option value="Y">N</option>
                  <option value="N">%</option>
                </select>
              </template>
              <a class="button sm" :class="{'disabled': ['', 'Duplicated'].includes(realfiltering.customCond.sign)}" href="#" @click.prevent="addFilter(realfiltering.columnName)">{{ $t('cp.COMMON.005') }}</a>
              <a class="button sm" href="#" @click.prevent="[dropdownRF('closeBtn'), clearRFcond()]">Close</a>
            </div>
          </div>
          <ul
            class="cp-scroll cp-ul cp-ul--cond cp-dropdown"
            :class="{
              'cp-dropdown--close': !realfiltering.dropdownInfo.layer2 || realfiltering.condFilterList.length === 0,
            }"
          >
            <li
              v-for="(filter, idx) in realfiltering.condFilterList" :key="idx"
              class="cp-li"
              :class="{
                'cp-li--selected': realfiltering.condFilterList.filter(condFilter => condFilter.active === true).map(condFilter2 => condFilter2.name).includes(filter.name),
                'cp-li--hide': filter.name === 'filter0',
              }"
              @click.prevent="controlFilter(realfiltering.columnName, [filter], 'condFilter')"
            >
              <input type="checkbox" name="no">
              <label :class="{'cp-pchkbox--selected': realfiltering.condFilterList.filter(condFilter => condFilter.active === true).map(condFilter2 => condFilter2.name).includes(filter.name)}"><span class="offscreen">No</span></label>
              <span>{{ filter.text }}</span>
              <button class="tbl_icon ml_auto minus" @click.stop="removeFilter(realfiltering.columnName, filter.name)">minus</button>
            </li>
          </ul>
          <div class="cp-li-header flex_box">
            <input type="checkbox" name="no">
            <label
              :class="{
                'cp-pchkbox--selected': realfiltering.filterType === 'valsFilter' && (
                  realfiltering.valsFilterList.filter(elem => elem.active).length === 0 ||
                  realfiltering.valsFilterList.length === realfiltering.valsFilterList.filter(elem => elem.active).length
                ),
                'cp-pchkbox--hide': realfiltering.searchKeyword !== ''
              }"
              @click.prevent="controlPchk(0, 'valsFilter')"
            >
              <span class="offscreen">No</span>
            </label>
            <input type="text" v-model="realfiltering.searchKeyword" :placeholder="$t('cp.COMMON.001')" :disabled="false">
          </div>
          <hr class="cp-hr">
          <ul class="cp-scroll cp-ul cp-ul--vals" :class="{'cp-ul--blank': realfiltering.valsFilterList.length === 0}">
            <li
              v-for="(filter, idx) in realfiltering.valsFilterList" :key="idx"
              class="cp-li"
              :class="{
                'cp-li--selected': realfiltering.filterType === 'valsFilter' && (
                  realfiltering.valsFilterList.filter(elem => elem.active).length === 0 ||
                  realfiltering.valsFilterList.filter(elem => elem.active).map(elem2 => elem2.name).includes(filter.name)
                ),
                'cp-li--hide': !filter.text.toLowerCase().includes(realfiltering.searchKeyword.toLowerCase())
              }"
              @click.prevent="controlFilter(realfiltering.columnName, [filter], 'valsFilter')"
            >
              <input type="checkbox" name="no">
              <label
                :class="{
                  'cp-pchkbox--selected': realfiltering.filterType === 'valsFilter' && (
                    realfiltering.valsFilterList.filter(elem => elem.active).length === 0 ||
                    realfiltering.valsFilterList.filter(elem => elem.active === true).map(elem2 => elem2.name).includes(filter.name)
                  )
                }"
              ><span class="offscreen">No</span></label>
              <span>{{ filter.text }}</span>
            </li>
          </ul>
        </div>
        <div id="realgrid" style="width: 100%; height: 536px; margin-top: 10px;" />
      </div>
    </div>
    <div class="flex_box mt10">
      <a class="button blue lg mr5" href="#" @click.prevent="mcs()">{{ $t('cp.CTRL020G070.031') }}</a>
      <a class="button blue lg mr5" href="#" @click.prevent="openPopup('SfOpportunityPop')">{{ $t('cp.CTRL020G070.033') }}</a>
      <a class="button blue lg mr5" href="#" @click.prevent="selectPromotion()">{{ $t('cp.CTRL020G070.034') }}</a>
      <a class="button blue lg mr5" href="#" @click.prevent="openPopup('SfLogPop')">{{ $t('cp.CTRL020G070.110') }}</a>
      <a class="button blue lg mr5 ml_auto" :class="{disabled: presGridLength === 0}" href="#" @click.prevent="exportExcelValidChk()">{{ $t('cp.CTRL020G070.105') }}</a>
      <a class="button blue lg mr5" :class="{disabled: groupKeyCheck.profileYn !== 'Y' || presGridLength === 0}" href="#" @click.prevent="openPopup('CpEmailPop')">{{ $t('cp.CTRL020G070.035') }}</a>
      <a class="button blue lg mr5" :class="{disabled: !(targetConfirmed || (groupKeyCheck.afterEntry === 'Y' && gridList.length !== 0))}" href="#" @click.prevent="getConfirmShipperInfo">{{ $t('cp.CTRL020G070.036') }}</a>
      <a class="button blue lg" :class="{disabled: !targetConfirmed}" href="#" @click.prevent="action">{{ $t('cp.CTRL020G070.037') }}</a>
    </div>
  </div>
</template>
<script>
import { createGrid } from '@/plugins/realgridUtil'
import scenarioTargetSet from '@/api/rest/cp/scenarioTargetSet'
import FactorList from '@/api/rest/cp/factorList'
import EBreadcrumbs from '@/components/common/EBreadcrumbs'
import cpCommonInfo from '@/api/rest/cp/cpCommonInfo'
import JSZip from 'jszip'
import moment from 'moment/moment'
import { rootComputed } from '@/store/helpers'

window.JSZip = window.JSZip || JSZip

let gridView = null
let provider = null

export const fields = [
  { fieldName: 'scenarioCd', dataType: 'text' },
  { fieldName: 'andor', dataType: 'text' },
  { fieldName: 'porCtr', dataType: 'text' },
  { fieldName: 'porPlc', dataType: 'text' },
  { fieldName: 'dlyCtr', dataType: 'text' },
  { fieldName: 'dlyPlc', dataType: 'text' },
  { fieldName: 'route', dataType: 'text' },
  { fieldName: 'itemGrp', dataType: 'text' },
  { fieldName: 'itemGrpNm', dataType: 'text' },
  { fieldName: 'item', dataType: 'text' },
  { fieldName: 'itemNm', dataType: 'text' },
  { fieldName: 'cntrSzTyp', dataType: 'text' },
  { fieldName: 'cntrSz', dataType: 'text' },
  { fieldName: 'cntrTyp', dataType: 'text' },
  { fieldName: 'frtPnc', dataType: 'text' },
  { fieldName: 'bidgCst', dataType: 'text' },
  { fieldName: 'bkgShipper', dataType: 'text' },
  { fieldName: 'bkgShipperNm', dataType: 'text' },
  { fieldName: 'salUnoBs', dataType: 'text' },
  { fieldName: 'actShipper', dataType: 'text' },
  { fieldName: 'actShipperNm', dataType: 'text' },
  { fieldName: 'hcneShipper', dataType: 'text' },
  { fieldName: 'hcneShipperNm', dataType: 'text' },
  { fieldName: 'salUnoHcs', dataType: 'text' },
  { fieldName: 'profile', dataType: 'text' },
  { fieldName: 'profileNm', dataType: 'text' },
  { fieldName: 'profileCatNm', dataType: 'text' },
  { fieldName: 'profileTel', dataType: 'text' },
  { fieldName: 'profileEml', dataType: 'text' },
  { fieldName: 'chk', dataType: 'text' }
]

export const columns = [
  { name: 'chk', fieldName: 'chk', type: 'text', header: { text: 'Check' }, visible: false },
  { name: 'porCtr', fieldName: 'porCtr', type: 'text', header: { template: `<span class='porCtr'>${app.$t('cp.CTRL020G070.040')}</span>`, text: app.$t('cp.CTRL020G070.040') }, width: 80, editable: false },
  { name: 'porPlc', fieldName: 'porPlc', type: 'text', header: { template: `<span class="porPlc"'>${app.$t('cp.CTRL020G070.041')}</span>`, text: app.$t('cp.CTRL020G070.041') }, width: 80, editable: false },
  { name: 'dlyCtr', fieldName: 'dlyCtr', type: 'text', header: { template: `<span class="dlyCtr"'>${app.$t('cp.CTRL020G070.042')}</span>`, text: app.$t('cp.CTRL020G070.042') }, width: 80, editable: false },
  { name: 'dlyPlc', fieldName: 'dlyPlc', type: 'text', header: { template: `<span class="dlyPlc"'>${app.$t('cp.CTRL020G070.043')}</span>`, text: app.$t('cp.CTRL020G070.043') }, width: 80, editable: false },
  { name: 'route', fieldName: 'route', type: 'text', header: { template: `<span class="route"'>${app.$t('cp.CTRL020G070.134')}</span>` }, width: 200, editable: false },
  { name: 'itemGrp', fieldName: 'itemGrp', type: 'text', visible: false },
  { name: 'itemGrpNm', fieldName: 'itemGrpNm', type: 'text', header: { template: `<span class="itemGrpNm"'>${app.$t('cp.CTRL020G070.103')}</span>`, text: app.$t('cp.CTRL020G070.103') }, width: 110, editable: false, styleName: 'text_left', renderer: { showTooltip: true } },
  { name: 'item', fieldName: 'item', visible: false },
  { name: 'itemNm', fieldName: 'itemNm', type: 'text', header: { template: `<span class="itemNm"'>${app.$t('cp.CTRL020G070.044')}</span>`, text: app.$t('cp.CTRL020G070.044') }, width: 110, editable: false, styleName: 'text_left', renderer: { showTooltip: true } },
  { name: 'cntrSzTyp', fieldName: 'cntrSzTyp', type: 'text', visible: false },
  { name: 'cntrSz', fieldName: 'cntrSz', type: 'text', header: { template: `<span class="cntrSz"'>${app.$t('cp.CTRL020G070.136')}</span>`, text: app.$t('cp.CTRL020G070.136') }, width: 70, editable: false },
  { name: 'cntrTyp', fieldName: 'cntrTyp', type: 'text', header: { template: `<span class="cntrTyp"'>${app.$t('cp.CTRL020G070.137')}</span>`, text: app.$t('cp.CTRL020G070.137') }, width: 70, editable: false },
  { name: 'frtPnc', fieldName: 'frtPnc', type: 'text', header: { template: `<span class="frtPnc"'>${app.$t('cp.CTRL020G070.138')}</span>`, text: app.$t('cp.CTRL020G070.138') }, width: 70, editable: false },
  { name: 'bidgCst', fieldName: 'bidgCst', type: 'text', header: { template: `<span class="bidgCst"'>${app.$t('cp.CTRL020G070.139')}</span>`, text: app.$t('cp.CTRL020G070.139') }, width: 100, editable: false },
  { name: 'bkgShipper', fieldName: 'bkgShipper', type: 'text', header: { template: `<span class="bkgShipper"'>${app.$t('cp.CTRL020G070.045')}</span>`, text: app.$t('cp.CTRL020G070.045') }, width: 110, editable: false, renderer: { showTooltip: true } },
  { name: 'bkgShipperNm', fieldName: 'bkgShipperNm', type: 'text', header: { template: `<span class="bkgShipperNm"'>${app.$t('cp.CTRL020G070.046')}</span>`, text: app.$t('cp.CTRL020G070.046') }, width: 140, editable: false, styleName: 'text_left', renderer: { showTooltip: true } },
  { name: 'salUnoBs', fieldName: 'salUnoBs', type: 'text', header: { template: `<span class="salUnoBs"'>${app.$t('cp.CTRL020G070.047')}</span>`, text: app.$t('cp.CTRL020G070.047') }, visible: false, width: 110, editable: false, renderer: { showTooltip: true } },
  { name: 'actShipper', fieldName: 'actShipper', visible: false },
  { name: 'actShipperNm', fieldName: 'actShipperNm', type: 'text', header: { template: `<span class="actShipperNm"'>${app.$t('cp.CTRL020G070.048')}</span>`, text: app.$t('cp.CTRL020G070.048') }, width: 140, editable: false, styleName: 'text_left', renderer: { showTooltip: true } },
  { name: 'hcneShipper', fieldName: 'hcneShipper', type: 'text', header: { template: `<span class="hcneShipper"'>${app.$t('cp.CTRL020G070.049')}</span>`, text: app.$t('cp.CTRL020G070.049') }, width: 110, editable: false, renderer: { showTooltip: true } },
  { name: 'hcneShipperNm', fieldName: 'hcneShipperNm', type: 'text', header: { template: `<span class="hcneShipperNm"'>${app.$t('cp.CTRL020G070.050')}</span>`, text: app.$t('cp.CTRL020G070.050') }, width: 140, editable: false, styleName: 'text_left', renderer: { showTooltip: true } },
  { name: 'salUnoHcs', fieldName: 'salUnoHcs', type: 'text', header: { template: `<span class="salUnoHcs"'>${app.$t('cp.CTRL020G070.051')}</span>`, text: app.$t('cp.CTRL020G070.051') }, visible: false, width: 70, editable: false, renderer: { showTooltip: true } },
  { name: 'profile', fieldName: 'profile', type: 'text', visible: false },
  { name: 'profileNm', fieldName: 'profileNm', type: 'text', header: { template: `<span class="profileNm"'>${app.$t('cp.CTRL020G070.053')}</span>`, text: app.$t('cp.CTRL020G070.053') }, width: 110, editable: false, styleName: 'text_left', renderer: { showTooltip: true } },
  { name: 'profileCatNm', fieldName: 'profileCatNm', type: 'text', header: { template: `<span class="profileCatNm"'>${app.$t('cp.CTRL020G070.104')}</span>`, text: app.$t('cp.CTRL020G070.104') }, width: 110, editable: false, styleName: 'text_left', renderer: { showTooltip: true } },
  { name: 'profileTel', fieldName: 'profileTel', type: 'text', header: { template: `<span class="profileTel"'>${app.$t('cp.CTRL020G070.054')}</span>`, text: app.$t('cp.CTRL020G070.054') }, visible: false, width: 130, editable: false, styleName: 'text_left', renderer: { showTooltip: true } },
  { name: 'profileEml', fieldName: 'profileEml', type: 'text', header: { template: `<span class="profileEml"'>${app.$t('cp.CTRL020G070.055')}</span>`, text: app.$t('cp.CTRL020G070.055') }, visible: false, width: 150, editable: false, styleName: 'text_left', renderer: { showTooltip: true } }
]

export const layout = [
  'porCtr',
  'porPlc',
  'dlyCtr',
  'dlyPlc',
  'route',
  'itemGrp',
  'itemGrpNm',
  'item',
  'itemNm',
  'cntrSzTyp',
  {
    name: 'cntrSzTypGrp',
    direction: 'horizontal',
    items: [
      'cntrSz',
      'cntrTyp'
    ],
    header: {
      text: app.$t('cp.CTRL020G070.131')
    }
  },
  'frtPnc',
  'bidgCst',
  'bkgShipper',
  'bkgShipperNm',
  'salUnoBs',
  'actShipper',
  'actShipperNm',
  'hcneShipper',
  'hcneShipperNm',
  'salUnoHcs',
  'profile',
  'profileNm',
  'profileCatNm',
  'profileTel',
  'profileEml'
]

export default {
  name: 'ScenarioTargetSet',
  components: {
    EBreadcrumbs,
    EDatePicker: () => import('@/components/common/EDatePicker'),
    WinLayerPop: () => import('@/pages/trans/popup/WinLayerPop'),
    FactorListPop: () => import('@/pages/cp/popup/FactorListPop'),
    CstSearchListPop: () => import('@/pages/cp/popup/CstSearchListPop'),
    ProfileListPop: () => import('@/pages/cp/popup/ProfileListPop'),
    ItemListPop: () => import('@/pages/cp/popup/ItemListPop'),
    CntrSzTypListPop: () => import('@/pages/cp/popup/CntrSzTypListPop'),
    ConfirmTargetPop: () => import('@/pages/cp/popup/ConfirmTargetPop'),
    CpEmailPop: () => import('@/pages/cp/popup/CpEmailPop'),
    SfOpportunityPop: () => import('@/pages/cp/popup/SfOpportunityPop'),
    SfPromotionPop: () => import('@/pages/cp/popup/SfPromotionPop'),
    SfPromotionActivityPop: () => import('@/pages/cp/popup/SfPromotionActivityPop'),
    SfLogPop: () => import('@/pages/cp/popup/SfLogPop'),
    TargetFactorCalcPop: () => import('@/pages/cp/popup/TargetFactorCalcPop'),
    TargetCondApplyPop: () => import('@/pages/cp/popup/TargetCondApplyPop')
  },
  data () {
    return {
      customComponent: null,
      parentInfo: {
        position: '',
        factorCd: '',
        factorCdC: '',
        factorType: '',
        tbIdYn: '',
        factorTypeC: '',
        equlSignType: '',
        itemGrp: [],
        item: [],
        ships: [],
        bkgShipper: [],
        profile: [],
        toEmail: '',
        confirmShipperInfo: '',
        sfOpt: {
          groupKeyCheck: null,
          scenarioNm: null,
          effectTo: null,
          fields: null,
          columns: null,
          columnLayout: null,
          gridList: null
        }
      },
      scenarioCd: '',
      gridList: [],
      presGridLength: 0,
      countryListForEntry: [],
      equalSignList: [],
      periodGbnList: [],
      eachPeriodGbnList: [],
      cmdtGrpList: [],
      routeList: [],
      frtPncList: [],
      bidgCstList: [],
      targetInfo: {
        scenarioNm: '',
        createUser: '',
        categoryCd: '',
        category: '',
        allShipperYn: '',
        mcsScenarioCd: ''
      },
      isShowHelp1: false,
      isShowHelp2: false,
      cpIsShowHelp: '',
      cpShowHelpText: {
        S07: this.$t('cp.CTRL020G070.062'),
        S08: this.$t('cp.CTRL020G070.063'),
        S09: this.$t('cp.CTRL020G070.064'),
        S10: this.$t('cp.CTRL020G070.065')
      },
      poptSearchKeyword: '',
      condLimitLength: 5,
      realfiltering: {
        columnName: '',
        valueType: '',
        filterType: '',
        pos: {
          top: -3000,
          left: -3000
        },
        customCond: {
          sign: '',
          condType: 'N',
          valA: '',
          valB: '',
          isConst: 'Y'
        },
        condFilterList: [],
        valsFilterList: [],
        searchKeyword: '',
        dropdownInfo: {
          layer1: false,
          layer2: false
        }
      },
      equalSignListRF: {
        number: [
          { sign: '=', condType: 'N', comment: this.$t('cp.CTRL020G070.066') },
          { sign: '<>', condType: 'N', comment: this.$t('cp.CTRL020G070.067') },
          { sign: '-', condType: '', comment: 'dummy' },
          { sign: '>', condType: 'N', comment: this.$t('cp.CTRL020G070.068') },
          { sign: '>=', condType: 'N', comment: this.$t('cp.CTRL020G070.069') },
          { sign: '<', condType: 'N', comment: this.$t('cp.CTRL020G070.070') },
          { sign: '<=', condType: 'N', comment: this.$t('cp.CTRL020G070.071') },
          { sign: 'A<=~<=B', condType: 'B', comment: this.$t('cp.CTRL020G070.072') },
          { sign: '-', condType: '', comment: 'dummy' },
          { sign: 'TOP', condType: 'P', comment: this.$t('cp.CTRL020G070.073') },
          { sign: 'BOTTOM', condType: 'P', comment: this.$t('cp.CTRL020G070.074') }
        ],
        text: [
          { sign: '=', condType: 'N', comment: this.$t('cp.CTRL020G070.066') },
          { sign: '<>', condType: 'N', comment: this.$t('cp.CTRL020G070.067') },
          { sign: '-', condType: '', comment: 'dummy' },
          { sign: 'A~', condType: 'Q', comment: this.$t('cp.CTRL020G070.075') },
          { sign: '~A', condType: 'Q', comment: this.$t('cp.CTRL020G070.076') },
          { sign: '-', condType: '', comment: 'dummy' },
          { sign: '~A~', condType: 'Q', comment: this.$t('cp.CTRL020G070.077') },
          { sign: 'NOT ~A~', condType: 'Q', comment: this.$t('cp.CTRL020G070.078') }
        ]
      },
      send: {
        keyCheck: {
          scenarioCd: '',
          porCtrYn: '',
          porPlcYn: '',
          dlyCtrYn: '',
          dlyPlcYn: '',
          routeYn: '',
          itemYn: '',
          bkgShipperYn: '',
          cntrSzTypYn: '',
          frtPncYn: '',
          bidgCstYn: '',
          actShipperYn: '',
          hcneShipperYn: '',
          profileYn: '',
          allShipperYn: ''
        },
        groupKeyCheck: {
          scenarioCd: '',
          porCtrYn: '',
          porPlcYn: '',
          dlyCtrYn: '',
          dlyPlcYn: '',
          routeYn: '',
          itemYn: '',
          bkgShipperYn: '',
          cntrSzTypYn: '',
          frtPncYn: '',
          bidgCstYn: '',
          actShipperYn: '',
          hcneShipperYn: '',
          profileYn: ''
        },
        keyInput: [{
          scenarioCd: '',
          keyNo: 1,
          porCtr: '',
          porPlc: [],
          dlyCtr: '',
          dlyPlc: [],
          route: [],
          itemGrp: [],
          item: [],
          itemLength: 0,
          lastItem: '',
          cntrSzTyp: [],
          cntrSzTypLength: 0,
          lastCntrSzTyp: '',
          frtPnc: '',
          bidgCst: '',
          bkgShipper: [],
          bkgShipLength: 0,
          lastBkgShip: '',
          actShipper: [],
          actShipLength: 0,
          lastActShip: '',
          hcneShipper: [],
          hcneShipLength: 0,
          lastHcneShip: '',
          profile: [],
          profileLength: 0,
          lastProfile: '',
          porHarborList: [],
          dlyHarborList: [],
          profileList: []
        }],
        condList: [
          [
            {
              scenarioCd: '',
              andor: 'OR-AND-1',
              factorNo: 1,
              factorCd: '',
              factorNm: '',
              refTable1: '',
              factorType: '',
              tbIdYn: '',
              periodUseYn: '',
              inputUseYn: '',
              periodDiv: '',
              updatePeriodYn: '',
              periodFr: '',
              periodTo: '',
              cstGrd: '',
              equlSign: '',
              compareOpt1: '',
              compareOpt2: 'N',
              compareOpt3: '↑',
              factorCdC: '',
              factorNmC: '',
              refTable1C: '',
              factorTypeC: '',
              periodUseYnC: '',
              inputUseYnC: '',
              periodDivC: '',
              periodFrC: '',
              periodToC: '',
              factorOpt1: '',
              factorOpt2: '',
              factorOpt1C: '',
              factorOpt2C: ''
            }
          ]
        ]
      },
      position: '',
      groupKeyCheck: {
        scenarioCd: '',
        porCtrYn: '',
        porPlcYn: '',
        dlyCtrYn: '',
        dlyPlcYn: '',
        routeYn: '',
        itemYn: '',
        cntrSzTypYn: '',
        frtPncYn: '',
        bidgCstYn: '',
        bkgShipperYn: '',
        actShipperYn: '',
        hcneShipperYn: '',
        profileYn: '',
        targetConfirmed: false,
        isEntry: '',
        afterEntry: '',
        confirmTargetYn: ''
      },
      popIdx: 0,
      targetConfirmed: false,
      confirmShipperInfo: [],
      tempList: [],
      confirmChk: 'N'
    }
  },
  computed: {
    ...rootComputed
  },
  created () {
    for (const type of ['mousedown', 'click']) {
      window.addEventListener(type, this.cpCustomEvent)
    }
  },
  mounted () {
    this.scenarioCd = this.$route.params.scenarioCd
    this.send.keyCheck.scenarioCd = this.$route.params.scenarioCd
    this.send.groupKeyCheck.scenarioCd = this.$route.params.scenarioCd
    this.send.keyInput[0].scenarioCd = this.$route.params.scenarioCd
    this.send.condList[0][0].scenarioCd = this.$route.params.scenarioCd

    const grid = createGrid('realgrid', {
      fields,
      columns,
      layout,
      header: { heights: [22, 23] },
      displayOptions: {
        rowHeight: 35,
        fitStyle: 'even',
        hscrollBar: true,
        selectionStyle: 'block',
        columnMovable: false
      },
      stateBar: {
        visible: false
      },
      rowIndicator: {
        visible: false
      },
      checkBar: {
        visible: true,
        syncHeadCheck: true
      },
      sortingOptions: {
        textCase: 'insensitive',
        keepFocusedRow: false,
        style: 'inclusive',
        showSortOrder: true
      },
      filteringOptions: {
        selector: {
          style: 'cp-oldfiltering'
        }
      }
    })
    gridView = grid.gridView
    provider = grid.provider

    gridView.header.showTooltip = undefined
    gridView.footers.visible = false

    const $vm = this

    $vm.getTargetInfo()
    $vm.getEqualSignList()
    $vm.getEachPeriodGbnList()
    $vm.getCmdtGrpList()
    $vm.getRouteList()
    $vm.getFrtPncList()
    $vm.getBidgCstList()
    $vm.getTargetCondList()
    $vm.getCountryListForEntry()

    // 그리드 행 체크 여부 확인
    gridView.onItemChecked = () => {
      $vm.confirmChk = 'N'
    }

    // 그리드 전체 체크 여부 확인
    gridView.onItemAllChecked = () => {
      $vm.confirmChk = 'N'
    }
  },
  beforeDestroy () {
    for (const type of ['mousedown', 'click']) {
      window.removeEventListener(type, this.cpCustomEvent)
    }
  },
  methods: {
    isAllShipper () {
      return this.targetInfo.allShipperYn === 'Y'
    },
    checkAllShipperState () {
      if (this.isAllShipper()) {
        this.asyncAlert(this.$t('cp.CTRL020G070.056'), 'off')
      } else {
        this.asyncAlert(this.$t('cp.CTRL020G070.057'), 'on')
      }
    },
    allShipperOn () {
      this.targetInfo.allShipperYn = 'Y'
      this.send.keyCheck.allShipperYn = this.targetInfo.allShipperYn
      scenarioTargetSet.saveScenarioTarget(this.postProcSend(this.send)).then(response => {
        if (this.isAllShipper()) {
          this.targetConfirmed = true
        }
      }).catch(err => {
        console.log(err)
      })
    },
    allShipperOff: function () {
      this.targetInfo.allShipperYn = 'N'
      if (!this.isAllShipper()) {
        this.targetConfirmed = false
      }
    },
    getEqualSignList: function () {
      cpCommonInfo.cpCommonCodeList('CP05').then(response => {
        const setEqualSignType = (cd) => {
          switch (true) {
            case ['S07', 'S08'].includes(cd): {
              return 'TB'
            }
            case ['S09', 'S10'].includes(cd): {
              return 'ID'
            }
            default: {
              return 'SI'
            }
          }
        }

        this.equalSignList = response.data.map(elem => (
          Object.assign(elem, { type: setEqualSignType(elem.detailCd) }))
        )
      }).catch(err => {
        console.log(err)
      })
    },
    getEqualSignType (cd) {
      return this.equalSignList.filter(elem => elem.detailCd === cd)?.[0]?.type
    },
    equalSignEvt (condRow) {
      // adjust compare opt
      const eqaulSignType = this.getEqualSignType(condRow.equlSign)
      if (eqaulSignType === 'SI') {
        condRow.compareOpt2 = ''
        condRow.compareOpt3 = ''
      } else {
        condRow.compareOpt2 = 'N'
        condRow.compareOpt3 = '↑'
      }

      // clear period
      if (eqaulSignType === 'TB') {
        condRow.factorCdC = ''
        condRow.factorNmC = ''
        condRow.periodUseYnC = 'N'
        condRow.periodFrC = ''
        condRow.periodToC = ''
        condRow.periodDivC = ''
      }
    },
    async getEachPeriodGbnList () {
      const periodGbnListRes = await cpCommonInfo.cpCommonCodeList('CP01').catch(err => { console.log(err) })
      const periodGbnList = periodGbnListRes.data
      FactorList.factorList().then(response => {
        this.eachPeriodGbnList = Object.fromEntries(response.data.map((row) => [row.factorCd, row.refTable1.split('.')[1]]))
        const periodMapper = {
          WB300S: [{ detailCd: 'P01', detailNm: this.$t('cp.CTRL020G070.058') }, { detailCd: 'P02', detailNm: this.$t('cp.CTRL020G070.059') }],
          WB302S: [{ detailCd: 'P01', detailNm: this.$t('cp.CTRL020G070.058') }, { detailCd: 'P02', detailNm: this.$t('cp.CTRL020G070.059') }, { detailCd: 'P06', detailNm: this.$t('cp.CTRL020G070.060') }],
          WB303S: [{ detailCd: 'P03', detailNm: this.$t('cp.CTRL020G070.061') }],
          WB304I: [{ detailCd: 'P03', detailNm: this.$t('cp.CTRL020G070.061') }],
          SA271H_TEMP: [{ detailCd: 'P03', detailNm: this.$t('cp.CTRL020G070.061') }],
          SA271H: [{ detailCd: 'P03', detailNm: this.$t('cp.CTRL020G070.061') }]
        }

        Object.entries(this.eachPeriodGbnList).forEach((elem, idx) => {
          const [factorCd, refTable] = elem
          if (Object.keys(periodMapper).includes(refTable)) {
            this.eachPeriodGbnList[factorCd] = periodMapper[refTable]
          } else if (factorCd === 'FC000') {
            this.eachPeriodGbnList[factorCd] = ['']
          } else {
            this.eachPeriodGbnList[factorCd] = periodGbnList
          }
        })
      }).catch(err => {
        console.log(err)
      })
    },
    getCmdtGrpList () {
      cpCommonInfo.cmdtGrpList().then(response => {
        this.cmdtGrpList = response.data
      }).catch(err => {
        console.error(err)
      })
    },
    getCmdtGrpVal (itemGrp) {
      return this.cmdtGrpList.filter(row => row.cmdtGrpCd === itemGrp)[0]?.cmdtGrpVal
    },
    getTargetInfo () {
      scenarioTargetSet.getTargetInfo(this.scenarioCd).then(response => {
        this.targetInfo = response.data
        if (this.isAllShipper()) {
          this.targetConfirmed = true
        }
      }).catch(err => {
        console.log(err)
      })
    },
    getTargetCondList () {
      scenarioTargetSet.getTargetCondList(this.scenarioCd).then(response => {
        this.send.keyCheck = response.data.keyCheck
        this.send.keyCheck.scenarioCd = this.$route.params.scenarioCd

        this.send.keyCheck.dlyCtrYn = 'Y'
        this.send.keyCheck.porCtrYn = 'Y'

        if (response.data.keyInput.length > 0) {
          const keyInput = response.data.keyInput
          const splitTargetList = ['porPlc', 'dlyPlc', 'route', 'itemGrp', 'item', 'cntrSzTyp', 'bkgShipper', 'actShipper', 'hcneShipper', 'profile']
          const initTextList = ['frtPnc', 'bidgCst']
          const initTargetList = [
            {
              list: 'itemGrp',
              length: 'itemLength',
              selected: 'lastItem'
            },
            {
              list: 'cntrSzTyp',
              length: 'cntrSzTypLength',
              selected: 'lastCntrSzTyp'
            },
            {
              list: 'bkgShipper',
              length: 'bkgShipLength',
              selected: 'lastBkgShip'
            },
            {
              list: 'actShipper',
              length: 'actShipLength',
              selected: 'lastActShip'
            },
            {
              list: 'hcneShipper',
              length: 'hcneShipLength',
              selected: 'lastHcneShip'
            },
            {
              list: 'profile',
              length: 'profileLength',
              selected: 'lastProfile'
            }
          ]

          keyInput.map(row => {
            for (const key of splitTargetList) {
              row[key] = ![undefined, null, ''].includes(row[key]) ? row[key].split(',') : []
            }

            for (const key of initTextList) {
              row[key] = row[key] !== undefined ? row[key] : ''
            }

            for (const target of initTargetList) {
              if (Array.isArray(row[target.list])) {
                if (row[target.list].length === 0) {
                  row[target.length] = 0
                  row[target.selected] = ''
                } else if (row[target.list].length >= 1) {
                  row[target.length] = row[target.list].length
                  row[target.selected] = row[target.list].at(-1)
                }
              }
            }

            row.route = row.route.filter(route => this.routeList.includes(route))

            if (row.lastItem !== '') {
              row.lastItem = this.getCmdtGrpVal(row.lastItem)
            }
            row.itemLength += row.item.length ? row.item.length : 0

            return row
          })

          this.send.keyInput = response.data.keyInput
        }

        if (response.data.condList.length > 0) {
          this.send.condList = []
          const condList = response.data.condList
          const andorList = [...new Set(condList.map(cond => cond.andor))]
          for (const andor of andorList) {
            this.send.condList.push([...condList.filter(cond => cond.andor === andor)])
          }
        }
        this.resetFactorNo()

        if (response.data.targetConfirmCnt > 0) {
          this.groupKeyCheck = response.data.groupKeyCheck
          this.targetConfirmed = true
          this.groupKeyCheck.targetConfirmed = true
          this.groupBy('')
        }
      }).catch(err => {
        console.error(err)
      })
    },
    getCountryListForEntry () {
      cpCommonInfo.countryListForEntry().then(response => {
        this.countryListForEntry = response.data
      }).catch(err => {
        console.log(err)
      })
    },
    async getHarborListForEntry (idx, type, value) {
      cpCommonInfo.harborListForEntry(value).then(response => {
        if (type.includes('por')) {
          this.send.keyInput[idx].porPlc = []
          this.send.keyInput[idx].porHarborList = response.data
        } else if (type.includes('dly')) {
          this.send.keyInput[idx].dlyPlc = []
          this.send.keyInput[idx].dlyHarborList = response.data
        }
      }).catch(err => {
        console.log(err)
      })
    },
    async getRouteList () {
      await cpCommonInfo.fairwayList().then(response => {
        this.routeList = response.data.map(elem => elem.rteCd)
      }).catch(err => {
        console.log(err)
      })
    },
    getFrtPncList () {
      cpCommonInfo.cpCommonCodeList('CP16').then(response => {
        this.frtPncList = response.data
      }).catch(err => {
        console.log(err)
      })
    },
    getBidgCstList () {
      cpCommonInfo.cpCommonCodeList('CP17').then(response => {
        this.bidgCstList = response.data
      }).catch(err => {
        console.log(err)
      })
    },
    changeDateRange (s, d) {
      this.param.effectFr = s
      this.param.effectTo = d
    },
    openAlert (msg) {
      let obj = {
        alertType: 'simple',
        onClose: this.closeFun,
        customCloseBtnClass: 'button blue lg simplert-test1',
        customCloseBtnText: this.$t('cp.COMMON.005'),
        useIcon: false,
        customClass: 'simple_alert',
        message: msg,
        type: 'info'
      }
      this.$ekmtcCommon.alert(obj)
    },
    setKeyCheck (position) {
      this.send.keyCheck[`${position}Yn`] = 'Y'
    },
    cpCustomEvent (e) {
      const type = e.type

      switch (type) {
        case 'mousedown': {
          // click anywhere
          this.controlPopt()

          // click filter icon
          const icon = this.getParentByClassName(e.target, 'rg-header-filtering')
          if (icon) {
            const columnName = e.target.previousSibling.childNodes[0].classList?.[0]

            if (columnName !== this.realfiltering.columnName) {
              this.openRF(columnName, icon)
            } else {
              this.closeRF()
            }
          // click filter inner
          } else if (this.getParentByClassName(e.target, 'cp-realfiltering')) {
            // pass
          // click filter outer
          } else {
            this.closeRF()
          }
          break
        }
        case 'dbclick': {
          break
        }
      }
    },
    getParentByClassName (target, className) {
      switch (true) {
        // itself
        case target.classList.contains(className): {
          return target
        }
        // sentinel
        case target.nodeName === 'HTML' || target.parentNode === document: {
          return undefined
        }
        // parent
        case target.parentNode.classList.contains(className): {
          return target.parentNode
        }
        // recursion
        default: {
          return this.getParentByClassName(target.parentNode, className)
        }
      }
    },
    clickPsel (idx, type) {
      const popt = document.querySelector(`#${type}Popt${idx}`)
      const poptSearch = document.querySelector(`#${type}Popt${idx}Search`)

      if (poptSearch) {
        setTimeout(() => {
          poptSearch.focus()
        }, 50)
      }

      this.controlPopt(popt)
    },
    controlPopt (targetPopt) {
      this.poptSearchKeyword = ''

      const poptList = document.querySelectorAll('.cp-popt')
      for (const popt of poptList) {
        if (popt !== targetPopt && !popt.classList.contains('cp-popt--close')) {
          popt.classList.add('cp-popt--close')
        }
      }

      if (targetPopt) {
        targetPopt.classList.toggle('cp-popt--close')

        const poptUl = targetPopt.querySelector('ul:last-child')
        for (const poptLi of poptUl.children) {
          if (poptLi.classList.contains('cp-li--selected')) {
            poptUl.scrollTop = (poptLi.offsetTop)
            break
          }
        }
      }
    },
    async clickPopt (idx, type, value) {
      switch (true) {
        case type.includes('Ctr'): {
          const isNewValue = this.send.keyInput[idx][type] !== value
          this.clearPopt(idx, type)

          if (isNewValue) {
            this.send.keyInput[idx][type] = value
            await this.getHarborListForEntry(idx, type, value)
            this.setKeyCheck(type)
          }

          const popt = document.querySelector(`#${type}Popt${idx}`)
          popt.classList.add('cp-popt--close')

          break
        }
        case type.includes('Plc'): {
          const targetList = this.send.keyInput[idx][type]

          if (!targetList.includes(value)) {
            targetList.push(value)
          } else {
            targetList.splice(targetList.indexOf(value), 1)
          }

          if (targetList.length !== 0) {
            this.setKeyCheck(type)
          }

          break
        }
        case type.includes('route'): {
          const targetList = this.send.keyInput[idx][type]

          if (!targetList.includes(value)) {
            targetList.push(value)
          } else {
            targetList.splice(targetList.indexOf(value), 1)
          }

          if (targetList.length !== 0) {
            this.setKeyCheck(type)
          }

          break
        }
        case type.includes('rf'): {
          const rfPopt = document.querySelector(`#${type}Popt${idx}`)
          const rfValA = document.querySelector('#rfValA')

          rfPopt.classList.add('cp-popt--close')
          if (rfValA) {
            setTimeout(() => {
              rfValA.focus()
            }, 50)
          }

          const [sign, condType] = value
          this.realfiltering.customCond = {
            sign: sign,
            condType: condType,
            valA: '',
            valB: '',
            isConst: 'Y'
          }

          break
        }
      }
    },
    controlPchk (idx, type) {
      switch (true) {
        case type.includes('Plc'): {
          const harborList = this.send.keyInput[idx][type.includes('por') ? 'porHarborList' : 'dlyHarborList']
          if (this.send.keyInput[idx][type].length === harborList.length) {
            this.send.keyInput[idx][type] = []
          } else {
            this.send.keyInput[idx][type] = [...harborList.map(row => row.plcCd)]
            this.setKeyCheck(type)
          }

          break
        }
        case type.includes('route'): {
          const routeList = this.routeList
          if (this.send.keyInput[idx][type].length === routeList.length) {
            this.send.keyInput[idx][type] = []
          } else {
            this.send.keyInput[idx][type] = [...routeList]
            this.setKeyCheck(type)
          }

          break
        }
        case type.includes('Filter'): {
          const columnName = this.realfiltering.columnName
          const [filterList, filterType] = type.includes('cond') ? [this.realfiltering.condFilterList, 'condFilter'] : [this.realfiltering.valsFilterList, 'valsFilter']
          const state = filterType === 'condFilter' ? true : (filterList.length === filterList.filter(elem => elem.active).length)
          const targetFilterList = filterList.filter(elem => elem.active === state)
          this.controlFilter(columnName, targetFilterList, filterType)

          break
        }
      }
    },
    clearPopt (idx, type) {
      switch (true) {
        case type.includes('por'): {
          if (type.includes('Ctr')) {
            this.send.keyInput[idx].porCtr = ''
            this.send.keyInput[idx].porHarborList = []
          }
          this.send.keyInput[idx].porPlc = []

          break
        }
        case type.includes('dly'): {
          if (type.includes('Ctr')) {
            this.send.keyInput[idx].dlyCtr = ''
            this.send.keyInput[idx].dlyHarborList = []
          }
          this.send.keyInput[idx].dlyPlc = []

          break
        }
      }
    },
    setLongestText (idx, type) {
      switch (true) {
        case type.includes('Ctr'): {
          const ctrEnmLengthList = this.countryListForEntry.map(row => row.ctrEnm.length)
          if (ctrEnmLengthList?.length === 0) {
            return 0
          } else {
            const longestCtrEnmLength = Math.max(...ctrEnmLengthList)
            const longestCtrEnmIdx = ctrEnmLengthList.indexOf(longestCtrEnmLength)
            const longestCtrEnm = this.countryListForEntry[longestCtrEnmIdx].ctrEnm

            return longestCtrEnm
          }
        }
        case type.includes('Plc'): {
          const harborList = this.send.keyInput[idx][type.includes('por') ? 'porHarborList' : 'dlyHarborList']
          const plcNmLengthList = harborList.map(row => row.plcNm.length)
          if (plcNmLengthList?.length === 0) {
            return 0
          } else {
            const longestPlcNmLength = Math.max(...plcNmLengthList)
            const longestPlcNmIdx = plcNmLengthList.indexOf(longestPlcNmLength)
            const longestPlcNm = harborList[longestPlcNmIdx].plcNm

            return longestPlcNm
          }
        }
        case type.includes('route'): {
          const routeList = this.routeList
          const routeLengthList = routeList.map(elem => elem.length)
          if (routeList?.length === 0) {
            return 0
          } else {
            const longestRouteLength = Math.max(...routeLengthList)
            const longestRouteIdx = routeLengthList.indexOf(longestRouteLength)
            const longestRoute = routeList[longestRouteIdx].plcNm

            return longestRoute
          }
        }
      }
    },
    setPselTxt (idx, type) {
      switch (true) {
        case type.includes('Ctr'): {
          const target = this.send.keyInput[idx][type]
          const targetMapperCtr = Object.fromEntries(this.countryListForEntry.map(row => [row.ctrCd, row.ctrEnm]))

          if (target) {
            return targetMapperCtr[target]
          } else {
            return this.$t('cp.COMMON.002')
          }
        }
        case type.includes('Plc'): {
          const harborList = this.send.keyInput[idx][type.includes('por') ? 'porHarborList' : 'dlyHarborList']
          const targetMapperPlc = Object.fromEntries(harborList.map(row => [row.plcCd, row.plcNm]))
          const targetList = this.send.keyInput[idx][type]

          if (targetList.length >= 1) {
            if (targetList.length > 1) {
              return `(${targetList.length}) ${targetMapperPlc[targetList.at(-1)]}`
            } else {
              return targetMapperPlc[targetList[0]]
            }
          } else {
            return this.$t('cp.COMMON.002')
          }
        }
        case type.includes('route'): {
          const selectedRoute = this.send.keyInput[idx][type]

          if (selectedRoute?.length >= 1) {
            if (selectedRoute.length > 1) {
              return `(${selectedRoute.length}) ${selectedRoute.at(-1)}`
            } else {
              return selectedRoute[0]
            }
          } else {
            return this.$t('cp.COMMON.002')
          }
        }
        case type.includes('rf'): {
          if (this.realfiltering.customCond.sign) {
            return this.realfiltering.customCond.sign
          } else {
            return this.$t('cp.COMMON.002')
          }
        }
      }
    },
    searchPopt (orgName, orgCode) {
      const keyword = this.poptSearchKeyword.toLowerCase()
      const name = orgName.toLowerCase()
      const code = orgCode.toLowerCase()
      const isHide = !(
        keyword === name.substr(0, keyword.length) ||
        keyword === code.substr(0, keyword.length)
      )

      return isHide
    },
    openRF (columnName, icon) {
      this.clearRFcond()
      this.controlRFicon(icon)
      this.realfiltering.searchKeyword = ''

      const target = document.getElementsByClassName(columnName)[0]
      const headerTag = this.getParentByClassName(target, 'rg-header-cell')
      const rf = document.querySelector('.cp-realfiltering')
      const rg = document.querySelector('#realgrid')

      if (headerTag) {
        const headerPos = headerTag.getBoundingClientRect()
        const rfPos = rf.getBoundingClientRect()
        const rgPos = rg.getBoundingClientRect()
        const filterList = gridView.getColumnFilters(columnName)

        const condFilterList = filterList.filter(elem => elem.name.includes('condFilter'))
        const valsFilterList = filterList.filter(elem => elem.name.includes('valsFilter'))

        const valueType = gridView.getColumnProperty(columnName, 'valueType')
        const filterType = (condFilterList.filter(elem => elem.active).length > valsFilterList.filter(elem => elem.active).length) ? 'condFilter' : 'valsFilter'

        this.realfiltering.columnName = columnName
        this.realfiltering.valueType = valueType
        this.realfiltering.filterType = filterType

        this.realfiltering.condFilterList.splice(0, this.realfiltering.condFilterList.length, ...condFilterList)
        this.realfiltering.valsFilterList.splice(0, this.realfiltering.valsFilterList.length, ...valsFilterList)

        this.realfiltering.pos.top = gridView.header.heights.reduce((acc, cur) => (acc + cur), 0)
        const rfLeft = (headerPos.right - rgPos.left)
        this.realfiltering.pos.left = rfLeft + rfPos.width < rgPos.width - 17 ? rfLeft : headerPos.left - rgPos.left - rfPos.width
      }
    },
    dropdownRF (type) {
      const cond = this.realfiltering.condFilterList.length !== 0
      const _ = undefined
      const is = (boolList) => {
        if (!Array.isArray(boolList) || boolList.length === 0) {
          return false
        }

        const infoList = Object.values(this.realfiltering.dropdownInfo)

        for (let i = 0; i < boolList.length; i++) {
          if (boolList[i] === undefined) {
            continue
          }

          if (boolList[i] !== infoList[i]) {
            return false
          }
        }
        return true
      }

      const to = (boolList) => {
        if (!Array.isArray(boolList) || boolList.length === 0) {
          return
        }

        for (let i = 0; i < boolList.length; i++) {
          if (boolList[i] === undefined) {
            continue
          }

          this.realfiltering.dropdownInfo[`layer${i + 1}`] = boolList[i]
        }
      }

      switch (type) {
        case 'header': {
          if (is([false, true])) { to([_, false]); break }
          if (is([false, false]) && cond) { to([_, true]); break }
          if (is([false])) { to([true, cond]); break }
          if (is([true])) { to([false, false]); break }
          break
        }
        case 'plusBtn': {
          if (is([false])) { to([true]) }
          break
        }
        case 'closeBtn': {
          to([false])
          break
        }
        case 'openList': {
          to([_, true])
          break
        }
        case 'closeList': {
          to([_, false])
          break
        }
        case 'toggleList': {
          if (is([_, true])) { to([_, false]); break }
          if (is([_, false])) { to([_, true]); break }
          break
        }
      }
    },
    clearRFcond () {
      this.realfiltering.customCond = {
        sign: '',
        condType: 'N',
        valA: '',
        valB: '',
        isConst: 'Y'
      }
    },
    setFilter () {
      for (const columnName of gridView.getColumnNames()) {
        // 1. get column value
        const columnValList1 = gridView.getJsonRows().map(row => row[columnName])

        // 2. remove duplicate & undefined value
        const columnValList2 = Array.from(new Set(columnValList1)).filter(val => !['', undefined, null].includes(val))

        // 3. type casting
        const valueType = gridView.getColumnProperty(columnName, 'valueType')
        const columnValList3 = valueType === 'number' ? columnValList2.map(val => !isNaN(val) ? Number(val) : undefined) : columnValList2

        // 4. sort
        const sortCallback = valueType === 'number' ? (a, b) => { return a - b } : undefined
        const columnValList4 = [undefined, ...columnValList3.sort(sortCallback)]

        // 5. set value filter
        const valsFilterList = []
        columnValList4.forEach((val, idx) => {
          valsFilterList.push({
            name: `valsFilter${idx}`,
            text: val === undefined ? this.$t('cp.CTRL020G070.080') : String(val),
            criteria: val === undefined ? 'value is empty' : (valueType === 'number' ? `value = ${val}` : `value = '${val}'`),
            active: false
          })
        })
        gridView.setColumnFilters(columnName, valsFilterList)
      }
    },
    controlFilter (columnName, targetFilterList, filterType) {
      const escape = !(this.realfiltering.filterType !== 'valsFilter' && filterType === 'valsFilter')
      this.realfiltering.filterType = filterType
      const valsFilterList = this.realfiltering.valsFilterList
      const condFilterList = this.realfiltering.condFilterList
      const control = (filterList, state) => {
        // https://stackoverflow.com/questions/63941282/does-array-filter-create-a-new-array
        if (state === 'toggle') {
          filterList.map(elem => (elem.active = !elem.active))
          gridView.toggleColumnFilters(columnName, filterList.map(elem => elem.name))
        } else {
          filterList.map(elem => (elem.active = (state === 'check')))
          gridView.activateColumnFilters(columnName, filterList.map(elem => elem.name), (state === 'check'))
        }
      }

      switch (filterType) {
        case 'condFilter': {
          control(valsFilterList.filter(elem => elem.active), 'uncheck')
          control(targetFilterList, 'toggle')
          break
        }
        case 'valsFilter': {
          control(condFilterList.filter(elem => elem.active), 'uncheck')
          if (targetFilterList.length === 1) {
            if (escape && valsFilterList.filter(elem => elem.active).length === 0) {
              control(valsFilterList, 'check')
              control(targetFilterList, 'uncheck')
            } else if (valsFilterList.filter(elem => elem.active).length === 1 && valsFilterList.filter(elem => elem.active)[0].name === targetFilterList[0].name) {
              this.realfiltering.filterType = ''
              control(targetFilterList, 'uncheck')
            } else if (valsFilterList.filter(elem => !elem.active).length === 1 && valsFilterList.filter(elem => !elem.active)[0].name === targetFilterList[0].name) {
              control(valsFilterList, 'uncheck')
            } else {
              control(targetFilterList, 'toggle')
            }
          } else {
            if (valsFilterList.filter(elem => elem.active).length === valsFilterList.length) {
              this.realfiltering.filterType = ''
              control(valsFilterList, 'uncheck')
            } else if (escape && this.realfiltering.filterType !== '' && valsFilterList.filter(elem => elem.active).length === 0) {
              this.realfiltering.filterType = ''
              control(valsFilterList, 'uncheck')
            } else {
              control(valsFilterList, 'uncheck')
            }
          }
          break
        }
      }

      this.presGridLength = gridView.getJsonRows(0, -1).length
    },
    uncheckFilter (columnName, filterName) {
      const isCond = filterName.includes('cond')
      if (isCond) {
        const targetIdx = this.realfiltering.condFilterList.map(elem => elem.name).indexOf(filterName)
        this.realfiltering.condFilterList[targetIdx].active = !this.realfiltering.condFilterList[targetIdx].active
        gridView.toggleColumnFilters(columnName, [filterName])
      } else {
        const targetIdx = this.realfiltering.condFilterList.map(elem => elem.name).indexOf(filterName)
        this.realfiltering.condFilterList[targetIdx].active = !this.realfiltering.condFilterList[targetIdx].active
        gridView.toggleColumnFilters(columnName, [filterName])
      }
    },
    addFilter (columnName) {
      // Custom Condition Info
      const sign = this.realfiltering.customCond.sign
      const condType = this.realfiltering.customCond.condType
      const comment = [...this.equalSignListRF.number, ...this.equalSignListRF.text].filter(row => row.sign === sign)[0].comment

      if (this.realfiltering.customCond.valA === '' && !['=', '<>'].includes(sign)) {
        document.querySelector('#rfValA').focus()
        return
      }

      // Added Filter Info
      const valueType = this.realfiltering.valueType
      const filterCount = this.realfiltering.condFilterList.length === 0 ? 1 : Math.max(...this.realfiltering.condFilterList.map(elem => elem.tag)) + 1

      const addedFilter = {
        name: `condFilter${filterCount}`,
        text: '',
        criteria: '',
        tag: filterCount,
        active: false
      }

      if (valueType === 'number') {
        const [valA, valB] = [this.realfiltering.customCond.valA, this.realfiltering.customCond.valB].map(val => val === '' ? '' : Number(val))
        switch (condType) {
          case 'N': {
            if (valA === '' && ['=', '<>'].includes(sign)) {
              addedFilter.text = `${sign} ${this.$t('cp.CTRL020G070.080')}`
              addedFilter.criteria = `value ${sign} empty`
            } else {
              addedFilter.text = `${sign} ${valA}`
              addedFilter.criteria = `value ${sign} ${valA}`
            }
            break
          }
          case 'B': {
            if (valB === '') {
              document.querySelector('#rfValB').focus()
              return
            }
            const [valMin, valMax] = [valA, valB].sort((a, b) => Number(a) - Number(b))
            addedFilter.text = `${comment} ${valMin} and ${valMax}`
            addedFilter.criteria = `(value >= ${valMin}) and (value <= ${valMax})`
            break
          }
          case 'P': {
            const isConst = this.realfiltering.customCond.isConst
            const order = sign === 'TOP' ? -1 : 1 // Desc (-1), Asc (1)
            const seriesData = provider.getJsonRows(0, -1).map(row => row[columnName]).filter(data => (data !== null && data !== undefined))
            const seriesDataSorted = seriesData.sort((a, b) => order * (a - b))
            const idx = isConst === 'Y' ? Number(valA) : Math.floor(seriesData.length * Number(valA) / 100)
            const targetValList = new Set(seriesDataSorted.slice(0, idx))

            const criteriaList = []
            for (const targetVal of targetValList) {
              criteriaList.push(`(value = ${targetVal})`)
            }

            addedFilter.text = `${sign.charAt(0) + sign.toLowerCase().slice(1)} ${valA}${isConst === 'Y' ? '' : ' %'}`
            addedFilter.criteria = criteriaList.join(' or ')
            break
          }
        }
      } else if (valueType === 'text') {
        const valA = this.realfiltering.customCond.valA
        switch (condType) {
          case 'N': {
            if (valA === '' && ['=', '<>'].includes(sign)) {
              addedFilter.text = `${comment} ${this.$t('cp.CTRL020G070.080')}`
              addedFilter.criteria = `value ${sign} empty`
            } else {
              addedFilter.text = `${comment} '${valA}'`
              addedFilter.criteria = `value ${sign} '${valA}'`
            }
            break
          }
          case 'Q': {
            const oper = !sign.includes('NOT') ? 'like' : 'not like'
            const trueVal = sign.replaceAll('~', '%').replace('NOT ', '').replace('A', valA)

            addedFilter.text = `${comment} '${valA}'`
            addedFilter.criteria = `value ${oper} '${trueVal}'`
            break
          }
        }
      }

      const textList = this.realfiltering.condFilterList.map(elem => elem.text)

      if (!textList.includes(addedFilter.text)) {
        const orgFilters = gridView.getColumnFilters(columnName)
        const newFilters = [...orgFilters, addedFilter]
        gridView.setColumnFilters(columnName, newFilters)
        this.realfiltering.condFilterList.push(addedFilter)
        this.clearRFcond()
      } else {
        this.realfiltering.customCond.sign = this.$t('cp.CTRL020G070.081')
        this.realfiltering.customCond.valA = ''
        document.querySelector('#rfValA').focus()
      }

      this.dropdownRF('openList')
    },
    removeFilter (columnName, filterName) {
      const targetIdx = this.realfiltering.condFilterList.map(elem => elem.name).indexOf(filterName)
      this.realfiltering.condFilterList.splice(targetIdx, 1)
      gridView.removeColumnFilters(columnName, [filterName])

      if (this.realfiltering.condFilterList.length === 0) {
        this.dropdownRF('closeList')
      }
    },
    closeRF () {
      this.controlRFicon()

      this.realfiltering = {
        columnName: '',
        valueType: '',
        filterType: '',
        pos: {
          top: -3000,
          left: -3000
        },
        customCond: {
          sign: '',
          condType: 'N',
          valA: '',
          valB: '',
          isConst: 'Y'
        },
        condFilterList: [],
        valsFilterList: [],
        searchKeyword: '',
        dropdownInfo: {
          layer1: false,
          layer2: false
        }
      }
    },
    controlRFicon (icon) {
      const prevIcon = document.querySelector('.rg-header-filtering--target')
      if (prevIcon) {
        prevIcon.classList.remove('rg-header-filtering--target')
      }

      if (icon) {
        icon.classList.add('rg-header-filtering--target')
      }
    },
    exportExcelValidChk () {
      if (gridView.getCheckedRows().length === 0) {
        this.openAlert(this.$t('cp.CTRL020G070.109'))
      } else {
        this.asyncAlert(this.$t('cp.CTRL020G070.106'), 'exportExcel')
      }
    },
    exportExcel () {
      const dateObj = new Date()
      const date = dateObj.getFullYear() + ('0' + (dateObj.getMonth() + 1)).slice(-2) + ('0' + dateObj.getDate()).slice(-2)
      const scenarioCd = this.scenarioCd
      const scenarioNm = this.targetInfo.scenarioNm
      const owner = this.targetInfo.createUser
      const actionCd = this.targetInfo.category

      const title = scenarioNm
      const subTitle = `Scn Code: ${scenarioCd} / Owner: ${owner} / Action Code: ${actionCd}`
      const fileName = `${scenarioCd}_${owner}_${date}.xlsx`
      const sheetName = scenarioCd

      gridView.exportGrid({
        type: 'excel',
        target: 'local',
        documentTitle: {
          message: title,
          visible: true,
          spaceTop: 0,
          spaceBottom: 0,
          height: 30,
          styleName: 'cp-excel-title'
        },
        documentSubtitle: {
          message: subTitle,
          spaceBottom: 1,
          visible: true,
          height: 20
        },
        fileName: fileName,
        showProgess: true,
        progressMessage: this.$t('cp.CTRL020G070.107'),
        indicator: 'hidden',
        applyFixed: false,
        header: 'visible',
        footer: 'hidden',
        onlyCheckedItems: true,
        compatibility: true,
        pagingAllItems: true,
        sheetAttrs: { showGridLines: '0' },
        exportTemplate: true,
        separateRows: true,
        exportGrids: [
          { grid: gridView, sheetName: sheetName }
        ]
      })

      this.openAlert(this.$t('cp.CTRL020G070.108'))
    },
    getSfOpt () {
      this.parentInfo.sfOpt.groupKeyCheck = this.groupKeyCheck
      this.parentInfo.sfOpt.scenarioNm = this.targetInfo.scenarioNm
      this.parentInfo.sfOpt.effectTo = (Array.from(this.targetInfo.effectTo).map((token, idx) => [3, 5].includes(idx) ? token + '-' : token)).join('')
      this.parentInfo.sfOpt.fields = provider.getFields().map(row => ({
        fieldName: row.orgFieldName,
        dataType: row.dataType
      }))
      this.parentInfo.sfOpt.columns = gridView.getColumns().map(row => ({
        name: row.name,
        fieldName: row.fieldName,
        header: {
          template: row.header.template,
          text: row.header.text?.replace('<br>', ' ')
        },
        visible: row.visible,
        width: row.width,
        editable: row.editable,
        styleName: row.styleName,
        renderer: {
          showTooltip: row.renderer?.showTooltip
        }
      }))
      const columnLayout = gridView.saveColumnLayout().filter(elem => !['route', 'cntrSzTypGrp'].includes(elem.name))
      this.parentInfo.sfOpt.columnLayout = columnLayout
      this.parentInfo.sfOpt.gridList = gridView.getJsonRows(0, -1).filter(row => row.chk === 'Y')
    },
    checkSfCommon () {
      const isExpiredDate = parseInt(this.targetInfo.effectTo.slice(0, 4)) >= 2100
      const isNotChkedItmes = gridView.getCheckedItems().length === 0

      if (isExpiredDate) {
        this.openAlert(this.$t('cp.CTRL020G070.123'))
        return false
      } else if (isNotChkedItmes) {
        this.openAlert(this.$t('cp.CTRL020G070.112'))
        return false
      }
      return true
    },
    checkInvalidCase (key, invalidCase) {
      const yn = this.send.keyCheck[key]
      if (yn !== 'Y') {
        return
      }

      const invalidCase1Info = []
      const invalidCase2Info = []
      for (const [condIdx, cond] of this.send.condList.entries()) {
        for (const [condRowIdx, condRow] of cond.entries()) {
          switch (condRow.refTable1) {
            case 'CP_INTERFACE.WB303S':
            case 'CP_INTERFACE.SA271H': {
              invalidCase1Info.push(`${this.$t('cp.CTRL020G070.151')} #${condIdx + 1} ${this.$t('cp.CTRL020G070.152')} ${condRowIdx + 1}, ${this.$t('cp.CTRL020G070.153')} : ${condRow.factorNm}`)
              break
            }
            case 'CP_INTERFACE.WB304I': {
              invalidCase2Info.push(`${this.$t('cp.CTRL020G070.151')} #${condIdx + 1} ${this.$t('cp.CTRL020G070.152')} ${condRowIdx + 1}, ${this.$t('cp.CTRL020G070.153')} : ${condRow.factorNm}`)
              break
            }
          }

          switch (condRow.refTable1C) {
            case 'CP_INTERFACE.WB303S':
            case 'CP_INTERFACE.SA271H': {
              invalidCase1Info.push(`${this.$t('cp.CTRL020G070.151')} #${condIdx + 1} ${this.$t('cp.CTRL020G070.152')} ${condRowIdx + 1}, ${this.$t('cp.CTRL020G070.153')}_C : ${condRow.factorNm}`)
              break
            }
            case 'CP_INTERFACE.WB304I': {
              invalidCase2Info.push(`${this.$t('cp.CTRL020G070.151')} #${condIdx + 1} ${this.$t('cp.CTRL020G070.152')} ${condRowIdx + 1}, ${this.$t('cp.CTRL020G070.153')}_C : ${condRow.factorNm}`)
              break
            }
          }
        }
      }

      if (
        (invalidCase === 'case1' && invalidCase1Info.length === 0) ||
        (invalidCase === 'case2' && invalidCase2Info.length === 0) ||
        (invalidCase === 'all' && invalidCase1Info.length === 0 && invalidCase2Info.length === 0)) {
        return
      }

      const invalidCaseContainer = document.createElement('ul')
      invalidCaseContainer.setAttribute('class', 'text_center cp-inner-container cp-scroll cp-scroll--auto mt10')
      switch (true) {
        case (['all', 'case1'].includes(invalidCase) && invalidCase1Info.length !== 0): {
          for (const info of invalidCase1Info) {
            const li = document.createElement('li')
            const txt = document.createTextNode(info)
            li.appendChild(txt)
            invalidCaseContainer.appendChild(li)
          }
          break
        }
        case (['all', 'case2'].includes(invalidCase) && invalidCase2Info.length !== 0): {
          for (const info of invalidCase2Info) {
            const li = document.createElement('li')
            const txt = document.createTextNode(info)
            li.appendChild(txt)
            invalidCaseContainer.appendChild(li)
          }
          break
        }
      }
      const msg = `${this.$t('cp.CTRL020G070.150')}<br>${invalidCaseContainer.outerHTML}`
      this.openAlert(msg)
    },
    checkInvalidRefTable (refTable1) {
      let invalidCase
      let refKeyList
      let msg

      switch (refTable1) {
        case 'CP_INTERFACE.WB303S':
        case 'CP_INTERFACE.SA271H': {
          invalidCase = 'case1'
          refKeyList = ['routeYn', 'itemYn', 'cntrSzTypYn', 'frtPncYn', 'actShipperYn']
          msg = this.$t('cp.CTRL020G070.148')

          break
        }
        case 'CP_INTERFACE.WB304I': {
          invalidCase = 'case2'
          refKeyList = ['routeYn', 'cntrSzTypYn', 'frtPncYn', 'bidgCstYn']
          msg = this.$t('cp.CTRL020G070.149')

          break
        }
      }

      if (invalidCase) {
        const isInvalidRefTable = Object.keys(this.send.keyCheck)
          .filter(key => refKeyList.includes(key))
          .map(key => this.send.keyCheck[key])
          .filter(yn => yn === 'Y').length !== 0

        if (isInvalidRefTable) {
          this.openAlert(msg)
        }
      }
    },
    async openPopup (compNm, position, idx) {
      if (this.customComponent !== null) {
        this.customComponent = null
        this.$ekmtcCommon.layerClose()
      } else {
        this.parentInfo.sfOpt = {
          groupKeyCheck: null,
          scenarioNm: null,
          effectTo: null,
          fields: null,
          columns: null,
          columnLayout: null,
          gridList: null
        }
      }

      this.setChkValue()
      this.parentInfo.position = position
      if (position === 'item') {
        this.parentInfo.itemGrp = this.send.keyInput[idx].itemGrp
        this.parentInfo.item = this.send.keyInput[idx].item
      } else if (position === 'cntrSzTyp') {
        this.parentInfo.cntrSzTyp = this.send.keyInput[idx].cntrSzTyp
      } else if (position === 'bkgShipper') {
        this.parentInfo.ships = this.send.keyInput[idx].bkgShipper
      } else if (position === 'actShipper') {
        this.parentInfo.ships = this.send.keyInput[idx].actShipper
      } else if (position === 'hcneShipper') {
        this.parentInfo.ships = this.send.keyInput[idx].hcneShipper
      } else if (position === 'profile') {
        this.parentInfo.bkgShipper = this.send.keyInput[idx].bkgShipper
        this.parentInfo.profile = this.send.keyInput[idx].profile
      } else if (position?.includes('-OR-AND-')) {
        const condIdx = parseInt(position.split('-OR-AND-')[1]) - 1
        const condRowIdx = idx
        this.parentInfo.factorCd = this.send.condList[condIdx][condRowIdx].factorCd
        this.parentInfo.factorType = this.send.condList[condIdx][condRowIdx].factorType
        this.parentInfo.factorCdC = this.send.condList[condIdx][condRowIdx].factorCdC
        this.parentInfo.factorTypeC = this.send.condList[condIdx][condRowIdx].factorTypeC
        this.parentInfo.equlSignType = this.getEqualSignType(this.send.condList[condIdx][condRowIdx].equlSign)
      }

      switch (compNm) {
        case 'ConfirmTargetPop': {
          this.parentInfo.confirmShipperInfo = this.confirmShipperInfo
          break
        }
        case 'CpEmailPop': {
          if (gridView.getCheckedRows().length === 0) {
            this.openAlert(this.$t('cp.CTRL020G070.109'))
            return
          } else {
            const chkedRows = gridView.getJsonRows().filter(row => row.chk === 'Y')
            const emlList = chkedRows.map(row => row.profileEml)
            const filteredEmlList = [...new Set(emlList.filter(eml => eml !== undefined))]
            this.parentInfo.toEmail = filteredEmlList.join(';')
          }

          break
        }
        case 'SfOpportunityPop': {
          const required = ['porCtrYn', 'dlyCtrYn', 'bkgShipperYn'].map(key => this.groupKeyCheck[key])
          const unnecess = ['routeYn', 'itemYn', 'cntrSzTypYn', 'frtPncYn', 'bidgCstYn', 'actShipperYn', 'hcneShipperYn', 'profileYn'].map(key => this.groupKeyCheck[key])
          const isOnlyRequired = required.every(yn => yn === 'Y')
          const isNotUnnecess = !unnecess.some(yn => yn === 'Y')

          if (!this.checkSfCommon()) {
            return
          } else if (!(isOnlyRequired && isNotUnnecess)) {
            this.openAlert(this.$t('cp.CTRL020G070.111'))
            return
          }
          this.getSfOpt()

          break
        }
        case 'SfPromotionPop': {
          const data = await scenarioTargetSet.salesforceUserCheck(this.$store.state.auth.loginInfo.userId).then(response => {
            return response.data
          }).catch(err => {
            console.error(err)
          })

          const required = ['porCtrYn', 'dlyCtrYn'].map(key => this.groupKeyCheck[key])
          const unnecess = ['routeYn', 'itemYn', 'cntrSzTypYn', 'frtPncYn', 'bidgCstYn', 'bkgShipperYn', 'actShipperYn', 'hcneShipperYn', 'profileYn'].map(key => this.groupKeyCheck[key])
          const isOnlyRequired = required.every(yn => yn === 'Y')
          const isNotUnnecess = !unnecess.some(yn => yn === 'Y')
          const isUnregiUser = data === 'NO'

          if (!(isOnlyRequired && isNotUnnecess)) {
            this.openAlert(this.$t('cp.CTRL020G070.119'))
            return
          } else if (isUnregiUser) {
            this.openAlert(this.$t('cp.CTRL020G070.127'))
            return
          }
          this.getSfOpt()

          break
        }
        case 'SfPromotionActivityPop': {
          const chkedRows = gridView.getJsonRows().filter(row => row.chk === 'Y')
          const promotionList = await scenarioTargetSet.scenarioPromotionCheck(chkedRows).then(response => {
            return response.data
          }).catch(err => {
            console.error(err)
          })
          const promotionChkResult = ['NO', 'NC'].includes(promotionList) ? promotionList : 'OK'
          const salesList = [...new Set(chkedRows.map(row => row.salUnoBs))]
          const promiseList = []
          for (const salUnoBs of salesList) {
            const promise = scenarioTargetSet.salesforceUserCheck(salUnoBs).then(response => {
              const data = {
                userId: salUnoBs,
                isValid: response.data
              }
              return data
            })
            promiseList.push(promise)
          }
          const salesAuthList = await Promise.allSettled(promiseList).then(response => {
            const data = response.map(elem => elem.value)
            return data.filter(elem => elem.isValid === 'OK').map(elem => elem.userId)
          }).catch(e => {
            console.error('promise-all', e)
          })

          const required = ['porCtrYn', 'dlyCtrYn', 'bkgShipperYn'].map(key => this.groupKeyCheck[key])
          const unnecess = ['routeYn', 'itemYn', 'cntrSzTypYn', 'frtPncYn', 'bidgCstYn', 'actShipperYn', 'hcneShipperYn', 'profileYn'].map(key => this.groupKeyCheck[key])
          const isOnlyRequired = required.every(yn => yn === 'Y')
          const isNotUnnecess = !unnecess.some(yn => yn === 'Y')
          const isNotExistPromotion = promotionChkResult === 'NO'
          const isNotMatchCorridor = promotionChkResult === 'NC' || (() => {
            if (promotionChkResult !== 'OK') {
              return false
            } else {
              const filteringReferKey = []
              for (const key of ['porCtr', 'porPlc', 'dlyCtr', 'dlyPlc']) {
                if (this.groupKeyCheck[`${key}Yn`] === 'Y') {
                  filteringReferKey.push(key)
                }
              }

              const getCorridorString = (row) => {
                return JSON.stringify(filteringReferKey.map(key => row[key]))
              }

              const validCorridorList = promotionList.map(row => getCorridorString(row))
              const authChkTargetSales = []
              chkedRows.map(row => {
                const corridorList = getCorridorString(row)
                if (validCorridorList.includes(corridorList)) {
                  authChkTargetSales.push(row.salUnoBs)
                }
              })

              if (authChkTargetSales.length === 0) {
                return false
              } else {
                const authTargetSales = []
                for (const targetSales of [...new Set(authChkTargetSales)]) {
                  if (salesAuthList.includes(targetSales)) {
                    authTargetSales.push(targetSales)
                  }
                }

                if (authTargetSales.length === 0) {
                  return true
                } else {
                  return false
                }
              }
            }
          })()

          const isMissingSales = chkedRows.filter(row => !row.salUnoBs).length !== 0
          const isAllUnregiUser = salesAuthList.length === 0

          if (!(isOnlyRequired && isNotUnnecess)) {
            this.openAlert(this.$t('cp.CTRL020G070.120'))
            return
          } else if (isMissingSales) {
            this.openAlert(this.$t('cp.CTRL020G070.128'))
            return
          } else if (isNotExistPromotion) {
            this.openAlert(this.$t('cp.CTRL020G070.121'))
            return
          } else if (isAllUnregiUser) {
            this.openAlert(this.$t('cp.CTRL020G070.129'))
            return
          } else if (isNotMatchCorridor) {
            this.openAlert(this.$t('cp.CTRL020G070.122'))
            return
          }
          this.getSfOpt()

          break
        }
        case 'SfLogPop': {
          this.parentInfo.sfOpt.groupKeyCheck = this.groupKeyCheck

          break
        }
        case 'TargetCondApplyPop': {
          const applyKeyList = [
            'routeYn',
            'itemYn',
            'cntrSzTypYn',
            'frtPncYn',
            'bidgCstYn',
            'bkgShipperYn',
            'actShipperYn',
            'hcneShipperYn',
            'profileYn'
          ]

          if (gridView.getCheckedRows().length === 0) {
            this.openAlert(this.$t('cp.CTRL020G070.145'))
            return
          } else if (applyKeyList.map(key => this.groupKeyCheck[key]).filter(yn => yn === 'Y').length === 0) {
            this.openAlert(this.$t('cp.CTRL020G070.146'))
            return
          }
          this.parentInfo.sfOpt.groupKeyCheck = this.groupKeyCheck

          break
        }
        case 'TargetFactorCalcPop': {
          this.parentInfo = this.send
          this.parentInfo.gridList = this.tempList
          this.parentInfo.groupKeyCheck = this.groupKeyCheck
          this.parentInfo.scenarioCd = this.scenarioCd
          this.parentInfo.scenarioNm = this.targetInfo.scenarioNm
          this.parentInfo.createUser = this.targetInfo.createUser
          this.parentInfo.category = this.targetInfo.category
          break
        }
      }

      this.customComponent = compNm
      this.position = position
      this.popIdx = idx
      this.confirmChk = 'Y'
      this.$ekmtcCommon.layerOpen('.sample_popup_list')
    },
    closePopup (obj, factorNm, refTable1, factorType, tbIdYn, periodUseYn, inputUseYn, isClearPeriod) {
      if (obj === undefined || obj === '' || obj === null) {
        this.customComponent = null
        this.$ekmtcCommon.layerClose('.sample_popup_list')
        return
      }

      this.checkInvalidRefTable(refTable1)

      switch (true) {
        case this.position.startsWith('L-'): {
          const condIdx = parseInt(this.position.split('-OR-AND-')[1]) - 1
          const condRowIdx = this.popIdx
          const factorCd = obj
          const condRow = this.send.condList[condIdx][condRowIdx]
          condRow.factorCd = factorCd
          condRow.factorNm = factorNm
          condRow.refTable1 = refTable1
          condRow.factorType = factorType
          condRow.tbIdYn = tbIdYn
          condRow.periodUseYn = periodUseYn
          condRow.inputUseYn = inputUseYn
          if (isClearPeriod) {
            condRow.periodFr = ''
            condRow.periodTo = ''
            condRow.periodDiv = ''
          }
          if (condRow.inputUseYn === 'N') {
            condRow.factorOpt1 = ''
            condRow.factorOpt2 = ''
          }
          const detailCdList = this.eachPeriodGbnList[condRow.factorCd].map((row) => row.detailCd)
          if (!detailCdList.includes(condRow.periodDiv)) {
            condRow.periodDiv = ''
          }

          break
        }
        case this.position.startsWith('R-'): {
          const condIdx = parseInt(this.position.split('-OR-AND-')[1]) - 1
          const condRowIdx = this.popIdx
          const factorCd = obj
          const condRow = this.send.condList[condIdx][condRowIdx]
          condRow.factorCdC = (factorCd === 'FC000') ? '' : factorCd
          condRow.factorNmC = (factorCd === 'FC000') ? '' : factorNm
          if (factorCd === 'FC000') {
            document.getElementById(`condFactorCdC-${condIdx}-${condRowIdx}`).readOnly = false
            document.getElementById(`condFactorCdC-${condIdx}-${condRowIdx}`).focus()
          } else {
            document.getElementById(`condFactorCdC-${condIdx}-${condRowIdx}`).readOnly = true
          }
          condRow.refTable1C = (factorCd === 'FC000') ? '' : refTable1
          condRow.factorTypeC = factorType
          condRow.periodUseYnC = periodUseYn
          condRow.inputUseYnC = inputUseYn
          if (isClearPeriod) {
            condRow.periodFrC = ''
            condRow.periodToC = ''
            condRow.periodDivC = ''
          }
          if (condRow.inputUseYnC === 'N') {
            condRow.factorOpt1C = ''
            condRow.factorOpt2C = ''
          }
          if (factorCd !== 'FC000') {
            const detailCdList = this.eachPeriodGbnList[condRow.factorCdC].map((row) => row.detailCd)
            if (!detailCdList.includes(condRow.periodDivC)) {
              condRow.periodDivC = ''
            }
          }

          break
        }
        case this.position === 'item': {
          this.send.keyInput[this.popIdx].itemGrp = obj.itemGrp
          this.send.keyInput[this.popIdx].item = obj.item
          this.send.keyInput[this.popIdx].itemLength = obj.itemGrp.length + obj.item.length
          this.send.keyInput[this.popIdx].lastItem = obj.lastItem
          if (this.send.keyInput[this.popIdx].itemGrp.length !== 0 || this.send.keyInput[this.popIdx].item.length !== 0) {
            this.setKeyCheck('item')
          }
          break
        }
        case this.position === 'cntrSzTyp': {
          this.send.keyInput[this.popIdx].cntrSzTyp = obj.cntrSzTyp
          this.send.keyInput[this.popIdx].cntrSzTypLength = obj.cntrSzTypLength
          this.send.keyInput[this.popIdx].lastCntrSzTyp = obj.lastCntrSzTyp
          if (this.send.keyInput[this.popIdx].cntrSzTyp.length !== 0) {
            this.setKeyCheck('cntrSzTyp')
          }

          break
        }
        case this.position === 'bkgShipper': {
          this.send.keyInput[this.popIdx].bkgShipper = obj.shipper
          this.send.keyInput[this.popIdx].bkgShipLength = obj.shipLength
          this.send.keyInput[this.popIdx].lastBkgShip = obj.lastShip
          this.send.keyInput[this.popIdx].profile = []
          this.send.keyInput[this.popIdx].profileLength = 0
          if (this.send.keyInput[this.popIdx].bkgShipper.length !== 0) {
            this.setKeyCheck('bkgShipper')
          }

          break
        }
        case this.position === 'actShipper': {
          this.send.keyInput[this.popIdx].actShipper = obj.shipper
          this.send.keyInput[this.popIdx].actShipLength = obj.shipLength
          this.send.keyInput[this.popIdx].lastActShip = obj.lastShip
          if (this.send.keyInput[this.popIdx].actShipper.length !== 0) {
            this.setKeyCheck('actShipper')
          }

          break
        }
        case this.position === 'hcneShipper': {
          this.send.keyInput[this.popIdx].hcneShipper = obj.shipper
          this.send.keyInput[this.popIdx].hcneShipLength = obj.shipLength
          this.send.keyInput[this.popIdx].lastHcneShip = obj.lastShip
          if (this.send.keyInput[this.popIdx].hcneShipper.length !== 0) {
            this.setKeyCheck('hcneShipper')
          }

          break
        }
        case this.position === 'profile': {
          this.send.keyInput[this.popIdx].profile = obj.profile
          this.send.keyInput[this.popIdx].profileLength = obj.profileLength
          this.send.keyInput[this.popIdx].lastProfile = obj.lastProfile
          if (this.send.keyInput[this.popIdx].profile.length !== 0) {
            this.setKeyCheck('profile')
          }

          break
        }
        case this.position === 'confirmTarget': {
          const confirmYn = obj
          if (confirmYn === 'Y') {
            this.target()
          }

          break
        }
        case this.position === 'targetCondApply': {
          const applyKeyList = obj.applyKeyList
          const initKeyList = [
            'route',
            'itemGrp',
            'item',
            'cntrSzTyp',
            'frtPnc',
            'bidgCst',
            'bkgShipper',
            'actShipper',
            'hcneShipper',
            'profile'
          ]

          for (const key of initKeyList) {
            this.send.keyCheck[`${key}Yn`] = applyKeyList.includes(key) ? 'Y' : ''
          }

          const chkedRowIdx = gridView.getCheckedRows()
          const chkedRow = provider.getJsonRows(0, -1).filter((_row, idx) => chkedRowIdx.includes(idx))
          const referData = {}
          for (const key of initKeyList) {
            if (applyKeyList.includes(key)) {
              referData[key] = [...new Set(chkedRow.map(row => row[key]))].filter(elem => !['', undefined, null].includes(elem))
            } else {
              referData[key] = []
            }
          }

          const appliedKeyInput = {
            scenarioCd: this.scenarioCd,
            keyNo: 1,
            porCtr: '',
            porPlc: [],
            dlyCtr: '',
            dlyPlc: [],
            route: Array.from(new Set(referData.route.flatMap(txt => txt.split('-')))).filter(route => this.routeList.includes(route)),
            itemGrp: referData.itemGrp,
            item: referData.item,
            itemLength: referData.itemGrp.length + referData.item.length,
            lastItem: this.getCmdtGrpVal(referData.itemGrp.at(-1)),
            cntrSzTyp: referData.cntrSzTyp,
            cntrSzTypLength: referData.cntrSzTyp.length,
            lastCntrSzTyp: referData.cntrSzTyp.at(-1),
            frtPnc: referData.frtPnc.length === 1 ? referData.frtPnc[0] : '',
            bidgCst: referData.bidgCst.length === 1 ? referData.bidgCst[0] : '',
            bkgShipper: referData.bkgShipper,
            bkgShipLength: referData.bkgShipper.length,
            lastBkgShip: referData.bkgShipper.at(-1),
            actShipper: referData.actShipper,
            actShipLength: referData.actShipper.length,
            lastActShip: referData.actShipper.at(-1),
            hcneShipper: referData.hcneShipper,
            hcneShipLength: referData.hcneShipper.length,
            lastHcneShip: referData.hcneShipper.at(-1),
            profile: referData.profile,
            profileLength: referData.profile.length,
            lastProfile: referData.profile.at(-1),
            porHarborList: [],
            dlyHarborList: [],
            profileList: []
          }

          this.send.keyInput.length = 0
          this.send.keyInput.push(appliedKeyInput)

          break
        }
      }

      this.customComponent = null
      this.$ekmtcCommon.layerClose('.sample_popup_list')
    },
    addRows () {
      this.send.keyInput.push(
        {
          scenarioCd: this.scenarioCd,
          keyNo: this.send.keyInput.length + 1,
          porCtr: '',
          porPlc: [],
          dlyCtr: '',
          dlyPlc: [],
          route: [],
          itemGrp: [],
          item: [],
          itemLength: 0,
          lastItem: '',
          cntrSzTyp: [],
          cntrSzTypLength: 0,
          lastCntrSzTyp: '',
          frtPnc: '',
          bidgCst: '',
          bkgShipper: [],
          lastBkgShip: '',
          bkgShipLength: 0,
          actShipper: [],
          actShipLength: 0,
          lastActShipper: '',
          hcneShipper: [],
          hcneShipLength: 0,
          lastHcneShipper: '',
          profile: [],
          profileLength: 0,
          lastProfile: '',
          porHarborList: [],
          dlyHarborList: [],
          profileList: []
        }
      )
    },
    removeRows (idx) {
      if (this.send.keyInput.length === 1) {
        return
      }
      this.send.keyInput.splice(idx, 1)
      this.send.keyInput.map((row, idx) => { row.keyNo = idx + 1 })
    },
    addCond () {
      if (this.send.condList.length < this.condLimitLength) {
        this.send.condList.push(
          [
            {
              scenarioCd: this.scenarioCd,
              andor: `OR-AND-${this.send.condList.length + 1}`,
              factorNo: 1,
              factorCd: '',
              factorNm: '',
              refTable1: '',
              factorType: '',
              tbIdYn: '',
              periodUseYn: '',
              inputUseYn: '',
              periodDiv: '',
              updatePeriodYn: '',
              periodFr: '',
              periodTo: '',
              cstGrd: '',
              equlSign: '',
              compareOpt1: '',
              compareOpt2: 'N',
              compareOpt3: '↑',
              factorCdC: '',
              factorNmC: '',
              refTable1C: '',
              factorTypeC: '',
              periodUseYnC: '',
              inputUseYnC: '',
              periodDivC: '',
              periodFrC: '',
              periodToC: '',
              factorOpt1: '',
              factorOpt2: '',
              factorOpt1C: '',
              factorOpt2C: ''
            }
          ]
        )
      } else {
        this.openAlert(this.convertCPLocale(this.$t('cp.CTRL020G070.079'), [this.condLimitLength]))
      }
    },
    addCondRows (condIdx) {
      this.send.condList[condIdx].push(
        {
          scenarioCd: this.scenarioCd,
          andor: `OR-AND-${condIdx + 1}`,
          factorNo: this.send.condList[condIdx].length + 1,
          factorCd: '',
          factorNm: '',
          refTable1: '',
          factorType: '',
          tbIdYn: '',
          periodUseYn: '',
          inputUseYn: '',
          periodDiv: '',
          updatePeriodYn: '',
          periodFr: '',
          periodTo: '',
          cstGrd: '',
          equlSign: '',
          compareOpt1: '',
          compareOpt2: 'N',
          compareOpt3: '↑',
          factorCdC: '',
          factorNmC: '',
          refTable1C: '',
          factorTypeC: '',
          periodUseYnC: '',
          inputUseYnC: '',
          periodDivC: '',
          periodFrC: '',
          periodToC: '',
          factorOpt1: '',
          factorOpt2: '',
          factorOpt1C: '',
          factorOpt2C: ''
        }
      )
    },
    async removeCond (condIdx) {
      if (condIdx !== 0) {
        if (await this.asyncAlert(this.convertCPLocale(this.$t('cp.CTRL020G070.082'), [(condIdx + 1)]), 'removeCond')) {
          this.send.condList.splice(condIdx, 1)
          this.resetAndor()
          this.resetFactorNo()
        }
      } else {
        return false
      }
    },
    removeCondRows (condIdx, condRowIdx) {
      if (this.send.condList[condIdx].length !== 1) {
        this.send.condList[condIdx].splice(condRowIdx, 1)
        this.resetAndor()
        this.resetFactorNo()
      } else {
        this.removeCond(condIdx)
      }
    },
    resetAllConds () {
      this.send.condList.length = 0
      this.send.condList = [
        [
          {
            scenarioCd: this.scenarioCd,
            andor: 'OR-AND-1',
            factorNo: 1,
            factorCd: '',
            factorNm: '',
            refTable1: '',
            factorType: '',
            tbIdYn: '',
            periodUseYn: '',
            inputUseYn: '',
            periodDiv: '',
            updatePeriodYn: '',
            periodFr: '',
            periodTo: '',
            cstGrd: '',
            equlSign: '',
            compareOpt1: '',
            compareOpt2: 'N',
            compareOpt3: '↑',
            factorCdC: '',
            factorNmC: '',
            refTable1C: '',
            factorTypeC: '',
            periodUseYnC: '',
            inputUseYnC: '',
            periodDivC: '',
            periodFrC: '',
            periodToC: '',
            factorOpt1: '',
            factorOpt2: '',
            factorOpt1C: '',
            factorOpt2C: ''
          }
        ]
      ]
    },
    resetAndor () {
      for (const [condIdx, cond] of this.send.condList.entries()) {
        cond.map(condRow => (condRow.andor = `OR-AND-${condIdx + 1}`))
      }
    },
    resetFactorNo () {
      for (const cond of this.send.condList) {
        for (const [condRowIdx, condRow] of cond.entries()) {
          condRow.factorNo = condRowIdx + 1
        }
      }
    },
    async asyncAlert (msg, typ) {
      let close = ''
      let confirm = ''

      switch (true) {
        case ['removeCond', 'exportExcel'].includes(typ): {
          close = this.$t('cp.COMMON.008')
          confirm = this.$t('cp.COMMON.005')
          break
        }
        case ['mc'].includes(typ): {
          close = this.$t('cp.COMMON.008')
          confirm = this.$t('cp.COMMON.011')
          break
        }
        default: {
          close = this.$t('cp.COMMON.007')
          confirm = this.$t('cp.COMMON.006')
          break
        }
      }

      const obj = {
        alertType: 'normal',
        showXclose: true,
        customCloseBtnClass: 'button blue lg',
        customCloseBtnText: close,
        customConfirmBtnText: confirm,
        customConfirmBtnClass: 'button blue lg',
        useConfirmBtn: true,
        title: this.$t('cp.CTRL020G070.001'),
        message: msg,
        type: 'info'
      }
      if (await this.$ekmtcCommon.asyncAlert(obj)) {
        switch (typ) {
          case 'entry': {
            this.entryAction()
            break
          }
          case 'target': {
            this.target()
            break
          }
          case 'on': {
            this.allShipperOn()
            break
          }
          case 'off': {
            this.allShipperOff()
            break
          }
          case 'exportExcel': {
            this.exportExcel()
            break
          }
          case 'mc': {
            return true
          }
          case 'removeCond': {
            return true
          }
          case 'reset': {
            this.resetAllConds()
            break
          }
          default: {
            return false
          }
        }
      }
    },
    entryValid () {
      //임시조치
      /*let today = moment()
      if (today.hour() < 18) {
        this.$ekmtcCommon.alertDefault(this.$t('cp.CTRL020G070.170'))
        return
      }*/

      this.resetFactorNo()

      // 최소 조건 입력 여부 검사
      const keyCheckList = [
        this.groupKeyCheck.porCtrYn,
        this.groupKeyCheck.porPlcYn,
        this.groupKeyCheck.dlyCtrYn,
        this.groupKeyCheck.dlyPlcYn,
        this.groupKeyCheck.routeYn,
        this.groupKeyCheck.itemYn,
        this.groupKeyCheck.cntrSzTypYn,
        this.groupKeyCheck.frtPncYn,
        this.groupKeyCheck.bidgCstYn,
        this.groupKeyCheck.bkgShipperYn,
        this.groupKeyCheck.actShipperYn,
        this.groupKeyCheck.hcneShipperYn,
        this.groupKeyCheck.profileYn,
        this.send.keyInput[0].porCtr,
        this.send.keyInput[0].porPlc,
        this.send.keyInput[0].dlyCtr,
        this.send.keyInput[0].dlyPlc,
        this.send.keyInput[0].itemGrp,
        this.send.keyInput[0].item,
        this.send.keyInput[0].bkgShipper,
        this.send.keyInput[0].actShipper,
        this.send.keyInput[0].hcneShipper,
        this.send.keyInput[0].profile
      ]

      if (keyCheckList.filter(row => row !== '' || (Array.isArray(row) && row.length !== 0)).length === 0) {
        this.openAlert(this.$t('cp.CTRL020G070.083'))
        return
      }

      const userCtrCd = this.auth.userCtrCd
      let isOk = true

      for (const key of this.send.keyInput) {
        if (this.$ekmtcCommon.isEmpty(key.porCtr) || this.$ekmtcCommon.isEmpty(key.dlyCtr)) {
          this.$ekmtcCommon.alertDefault(this.$t('cp.CTRL020G070.172'))
          isOk = false
          break
        }

        // 국내 사용자가 아닐 경우 DLYm POR 선택 시 둘 중 하는 본인 나라 선택
        if (userCtrCd !== 'KR') {
          let porCtr = key.porCtr.split('-')[0]
          let dlyCtr = key.dlyCtr.split('-')[0]

          if (userCtrCd !== porCtr && userCtrCd !== dlyCtr) {
            this.$ekmtcCommon.alertDefault(this.$t('cp.CTRL020G070.171'))
            isOk = false
            break
          }
        }
      }

      if (!isOk) return

      const condList = this.postProcSend(this.send).condList // 기본 조건 조합위치
      for (const cond of condList) {
        // Row 별 빈 항목 검사
        const condCheckList = [cond.factorCd, cond.equlSign, cond.factorCdC]

        if (cond.inputUseYn === 'Y') {
          condCheckList.push(cond.factorOpt1, cond.factorOpt2)
        }

        if (cond.inputUseYnC === 'Y') {
          condCheckList.push(cond.factorOpt1C, cond.factorOpt2C)
        }

        if (cond.periodUseYn === 'Y') {
          condCheckList.push(cond.periodDiv, cond.periodFr, cond.periodTo)
        }

        if (cond.periodUseYnC === 'Y') {
          condCheckList.push(cond.periodDivC, cond.periodFrC, cond.periodToC)
        }

        const isTypeTbId = ['TB', 'ID'].includes(this.getEqualSignType(cond.equlSign))
        if (isTypeTbId) {
          condCheckList.push(cond.compareOpt1)
        }

        if (condCheckList.filter((row) => row === '').length !== 0) {
          this.openAlert(this.convertCPLocale(this.$t('cp.CTRL020G070.084'), [cond.andor.replace('OR-AND-', ''), cond.factorNo]))
          return
        }

        // 위에서 condCheckList 빈 값 체크하고 이후 아래 화주등급 추가하는 이유는, 빈 값인 경우 화주등급 전체 선택이기에, 여기서 condCheckList에 화주등급 추가함
        condCheckList.push(cond.cstGrd)

        // 날짜 유효성 검사
        if ((cond.periodFr !== '' && cond.periodTo !== '' && cond.periodFr > cond.periodTo) ||
            (cond.periodFrC !== '' && cond.periodToC !== '' && cond.periodFrC > cond.periodToC)) {
              this.openAlert(this.convertCPLocale(this.$t('cp.CTRL020G070.085'), [cond.andor.replace('OR-AND-', ''), cond.factorNo]))
          return
        }

        if (!this.validateDate(cond)) {
          return
        }

        //직접입력
        if (cond.factorCdC === '' || cond.factorCdC === '0' || cond.factorCdC === 0) {
          this.$ekmtcCommon.alertDefault(this.$t('cp.CTRL020G070.174'))
          return
        }

        // factor값 유형 검사
        if (cond.factorTypeC !== '' && cond.factorType !== cond.factorTypeC) {
          this.openAlert(this.convertCPLocale(this.$t('cp.CTRL020G070.086'), [cond.andor.replace('OR-AND-', ''), cond.factorNo]))
          return
        }
      }
      this.asyncAlert(this.$t('cp.CTRL020G070.087'), 'entry')
    },
    postProcSend (send) {
      const sendCopy = JSON.parse(JSON.stringify(send))
      const postProcCondRow = (condRow) => {
        switch (this.getEqualSignType(condRow.equlSign)) {
          case 'TB': {
            condRow.factorCdC = condRow.compareOpt1
            condRow.compareOpt3 = ''
            break
          }
          case 'SI': {
            condRow.compareOpt1 = ''
            condRow.compareOpt2 = ''
            condRow.compareOpt3 = ''
            break
          }
        }
        return condRow
      }

      const joinTargetList = ['porPlc', 'dlyPlc', 'route', 'itemGrp', 'item', 'cntrSzTyp', 'bkgShipper', 'actShipper', 'hcneShipper', 'profile']

      const sendPostProc = {
        keyCheck: sendCopy.keyCheck,
        groupKeyCheck: sendCopy.groupKeyCheck,
        keyInput: [...sendCopy.keyInput].map((row) => {
          for (const key of joinTargetList) {
            row[key] = Array.isArray(row[key]) && row[key].length !== 0 ? row[key].join(',') : ''
          }
          return row
        }),
        condList: ([].concat(...sendCopy.condList).map(condRow => postProcCondRow(condRow)))
      }

      return sendPostProc
    },
    entryAction () {
      this.send.keyCheck.allShipperYn = 'N'
      scenarioTargetSet.saveScenarioTarget(this.postProcSend(this.send)).then(response => {
        if (response.data === 'OK') {
          this.groupKeyCheck.porCtrYn = this.send.keyCheck.porCtrYn
          this.groupKeyCheck.porPlcYn = this.send.keyCheck.porPlcYn
          this.groupKeyCheck.dlyCtrYn = this.send.keyCheck.dlyCtrYn
          this.groupKeyCheck.dlyPlcYn = this.send.keyCheck.dlyPlcYn
          this.groupKeyCheck.routeYn = this.send.keyCheck.routeYn
          this.groupKeyCheck.itemYn = this.send.keyCheck.itemYn
          this.groupKeyCheck.cntrSzTypYn = this.send.keyCheck.cntrSzTypYn
          this.groupKeyCheck.frtPncYn = this.send.keyCheck.frtPncYn
          this.groupKeyCheck.bidgCstYn = this.send.keyCheck.bidgCstYn
          this.groupKeyCheck.bkgShipperYn = this.send.keyCheck.bkgShipperYn
          this.groupKeyCheck.actShipperYn = this.send.keyCheck.actShipperYn
          this.groupKeyCheck.hcneShipperYn = this.send.keyCheck.hcneShipperYn
          this.groupKeyCheck.profileYn = this.send.keyCheck.profileYn
          this.groupKeyCheck.targetConfirmed = false
          this.groupKeyCheck.isEntry = 'Y'
          this.groupKeyCheck.afterEntry = 'Y'
          this.targetConfirmed = false

          this.groupBy('')
        } else {
          this.$ekmtcCommon.alertCallback(this.$t('cp.CTRL020G070.089'), () => {})
        }
      }).catch(err => {
        console.log(err)
      })
    },
    groupBy (typ) {
      if (typ === '') {
        this.groupKeyCheck.scenarioCd = this.scenarioCd

        // 화주등급 중복 제거 및 추출용
        const condList = this.postProcSend(this.send).condList
        const cstGrdList = []

        condList.forEach((ele) => {
          if (!cstGrdList.includes(ele.cstGrd) && ele.cstGrd !== '') {
            cstGrdList.push(ele.cstGrd)
          }
        })

        this.groupKeyCheck = Object.assign({}, this.groupKeyCheck, { cstGrd: cstGrdList.join(',') })

        scenarioTargetSet.targetGroupby(this.groupKeyCheck).then(response => {
          this.setGridList(response.data)
          this.setFilter()
          this.updateSorting()
          this.updateGridVisibleOpt(typ)
          this.updateCheckState()
          this.groupKeyCheck.isEntry = 'N'
        }).catch(err => {
          console.error(err)
        })
      }
    },
    setGridList (data) {
      if (data.length === 0) {
        this.gridList = []
        this.presGridLength = 0
        if (this.groupKeyCheck.cntrSzTypYn === 'Y') {
          gridView.header.heights = [22, 23]
        } else {
          gridView.header.heights = [45]
        }
        gridView.columnByName('route').visible = false
        gridView.setColumnLayout(layout)
        provider.setRows([])

        return
      }

      // https://gist.github.com/mikaello/06a76bca33e5d79cdd80c162d7774e9c
      const groupByResponseData = (keys) => (array) => (
        array.reduce((acc1, cur1) => {
          keys.reduce((acc2, cur2, idx2) => {
            if (idx2 !== keys.length - 1) {
              acc2[cur1[cur2]] = acc2[cur1[cur2]] || {}
            } else {
              acc2[cur1[cur2]] = (acc2[cur1[cur2]] || []).concat(cur1)
            }
            return acc2[cur1[cur2]]
          }, acc1)
          return acc1
        }, {})
      )

      const getLeafNodes = (nodes, result = []) => {
        for (const val of Object.values(nodes)) {
          if (Array.isArray(val) && val !== undefined && val.length !== 0) {
            result.push(val)
          } else {
            result = getLeafNodes(val, result)
          }
        }
        return result
      }

      const sortbyCondFactorCd = (dynamicLayoutInfo) => {
        const order = []
        this.send.condList.map(cond => cond.map(row => {
          const andorNo = parseInt(row.andor.replace('OR-AND-', ''))
          order.push(...[`${andorNo}-${row.factorNo}-${row.factorCd}`, `${andorNo}-${row.factorNo}-${row.factorCdC}_C`])
        }))

        for (const info of Object.values(dynamicLayoutInfo)) {
          info.items.sort((a, b) => {
            if (order.indexOf(a) < order.indexOf(b)) {
              return -1
            } else if (order.indexOf(a) > order.indexOf(b)) {
              return 1
            } else {
              return 0
            }
          })
        }
      }

      const checkMapper = {
        porCtr: 'porCtrYn',
        porPlc: 'porPlcYn',
        dlyCtr: 'dlyCtrYn',
        dlyPlc: 'dlyPlcYn',
        route: 'routeYn',
        item: 'itemYn',
        cntrSzTyp: 'cntrSzTypYn',
        frtPnc: 'frtPncYn',
        bidgCst: 'bidgCstYn',
        bkgShipper: 'bkgShipperYn',
        actShipper: 'actShipperYn',
        hcneShipper: 'hcneShipperYn',
        profile: 'profileYn'
      }

      const staticColumnNm = fields.map(col => col.fieldName)
      const chkedGroupKeyYn = Object.keys(this.groupKeyCheck).filter(chk => (this.groupKeyCheck[chk] === 'Y'))
      const groupByReferKey = Object.keys(checkMapper).filter(key => (chkedGroupKeyYn.includes(checkMapper[key])))
      const routeLengthList = data.map(row => row.route?.split('-').length)
      const maxRouteCount = Math.max(...routeLengthList) > 0 ? Math.max(...routeLengthList) : 1
      const gridList = []
      const dynamicColumnInfo = {}
      const dynamicLayoutInfo = {}

      for (const pairRow of getLeafNodes(groupByResponseData(groupByReferKey)(data))) {
        const postProcRow = {}
        for (const key of staticColumnNm) {
          postProcRow[key] = pairRow[0][key]
        }

        const routeList = typeof pairRow[0].route === 'string' ? pairRow[0].route.split('-') : []
        if (routeList.length === 1) {
          postProcRow.route1 = routeList[0]
          postProcRow.first = routeList[0]
        } else if (routeList.length > 1) {
          for (let i = 0; i < maxRouteCount; i++) {
            postProcRow[`route${i + 1}`] = routeList[i]
          }
          postProcRow.first = routeList[0]
          postProcRow.last = routeList.at(-1)
        }

        const cntrSzTyp = typeof pairRow[0].cntrSzTyp === 'string' ? pairRow[0].cntrSzTyp : ''
        if (cntrSzTyp !== '') {
          const [cntrSz, cntrTyp] = cntrSzTyp.split('-')
          postProcRow.cntrSz = cntrSz
          postProcRow.cntrTyp = cntrTyp
        }

        for (let i = 0; i < pairRow.length; i++) {
          const checkValueList = [pairRow[i].factorCd, pairRow[i].factorNm, pairRow[i].measures]

          if (checkValueList.every(value => value !== undefined)) {
            const andorNo = parseInt(pairRow[i].andor.replace('OR-AND-', ''))
            const delimiter = ' | '
            const newFactorCd = pairRow[i].factorCd.split(delimiter).map(factorCd => `${andorNo}-${factorCd}`)
            const newFactorNm = pairRow[i].factorNm.split(delimiter)
            const newMeasures = pairRow[i].measures.split(delimiter)

            for (let j = 0; j < newFactorCd.length; j++) {
              const factorCd = newFactorCd[j]
              const factorNm = newFactorNm[j]
              const measures = newMeasures[j]

              if (!(factorCd in dynamicColumnInfo)) {
                dynamicColumnInfo[factorCd] = factorNm
              }

              if (!(factorCd in postProcRow)) {
                postProcRow[factorCd] = measures
              } else {
                postProcRow[factorCd] += `, ${measures}`
              }
            }
          }
        }
        gridList.push(postProcRow)
      }

      const validCondNoList = Array.from(new Set(Object.keys(dynamicColumnInfo).map(row => parseInt(row.split('-')[0])))).sort((a, b) => a - b)
      for (const validCondNo of validCondNoList) {
        dynamicLayoutInfo[`factorGrp${validCondNo}`] = {
          name: `factorGrp${validCondNo}`,
          direction: 'horizontal',
          items: [],
          header: {
            text: ''
          }
        }
      }

      const dynamicFields = []
      const dynamicColumns = []

      for (const fieldName of Object.keys(dynamicColumnInfo)) {
        const andorNo = parseInt(fieldName.split('-')[0])
        const columnValList = gridList.map(row => row[fieldName] !== undefined ? row[fieldName] : '0')
        const dataType = columnValList.every(x => !isNaN(x)) ? 'number' : 'text'

        dynamicFields.push(
          Object.assign({
            fieldName: fieldName, dataType: dataType
          },
          dataType === 'number' ? ({
            subType: columnValList.every(x => Number.isInteger(Number(x))) ? 'int' : ''
          }) : {})
        )

        dynamicColumns.push(
          Object.assign({
            name: fieldName,
            fieldName: fieldName,
            type: dataType,
            header: {
              template: `<span class="${fieldName}">${dynamicColumnInfo[fieldName]}</span>`,
              text: dynamicColumnInfo[fieldName],
              showTooltip: true
            }
          },
          dataType === 'number' ? ({
            numberFormat: columnValList.every(x => Number.isInteger(Number(x))) ? '#,##0' : '#,##0.0',
            styleName: 'text_center'
          }) : {},
          {
            visible: true,
            width: 100,
            editable: false,
            renderer: { showTooltip: true }
          })
        )

        dynamicLayoutInfo[`factorGrp${andorNo}`].items.push(fieldName)
        dynamicLayoutInfo[`factorGrp${andorNo}`].header.text = `${this.$t('cp.CTRL020G070.019')}${andorNo}`
      }
      sortbyCondFactorCd(dynamicLayoutInfo)

      gridView.setCheckBar({ syncHeadCheck: false })
      const fieldRouteIdx = fields.map(elem => elem.fieldName).indexOf('route')
      const columnRouteIdx = columns.map(elem => elem.fieldName).indexOf('route')
      const layoutRouteIdx = columnRouteIdx
      const isRouteVisible = this.groupKeyCheck.routeYn === 'Y'

      // https://forum.realgrid.com/topics/iMh4drQeXxRNwfhTM
      provider.setFields([
        ...fields.slice(0, fieldRouteIdx),
        ...Array(maxRouteCount).fill().map((_elem, idx) => ({
          fieldName: `route${idx + 1}`, type: 'text'
        })),
        { fieldName: 'first', type: 'text' },
        { fieldName: 'last', type: 'text' },
        ...fields.slice(fieldRouteIdx),
        ...dynamicFields
      ])

      gridView.setColumns([
        ...columns.slice(0, columnRouteIdx),
        ...Array(maxRouteCount).fill().map((_elem, idx) => ({
          name: `route${idx + 1}`,
          fieldName: `route${idx + 1}`,
          type: 'text',
          width: 80,
          visible: isRouteVisible,
          editable: false,
          header: {
            template: `<sapn class="route${idx + 1}">${this.$t('cp.CTRL020G070.130')}${idx + 1}</sapn>`,
            text: 'ROUTE' + (idx + 1)
          }
        })),
        {
          name: 'first',
          fieldName: 'first',
          type: 'text',
          width: 80,
          visible: isRouteVisible,
          editable: false,
          header: {
            text: this.$t('cp.CTRL020G070.140'),
            template: `<sapn class="first">${this.$t('cp.CTRL020G070.140')}</sapn>`
          }
        },
        {
          name: 'last',
          fieldName: 'last',
          type: 'text',
          width: 80,
          visible: isRouteVisible && maxRouteCount > 1,
          editable: false,
          header: {
            text: this.$t('cp.CTRL020G070.141'),
            template: `<sapn class="last">${this.$t('cp.CTRL020G070.141')}</sapn>`
          }
        },
        ...columns.slice(columnRouteIdx),
        ...dynamicColumns
      ])
      gridView.setColumnLayout([
        ...layout.slice(0, layoutRouteIdx),
        {
          name: 'route',
          direction: 'horizontal',
          items: [
            ...Array(maxRouteCount).fill().map((_elem, idx) => `route${idx + 1}`),
            'first',
            'last'
          ],
          header: {
            text: app.$t('ROUTE')
          }
        },
        ...layout.slice(layoutRouteIdx),
        ...Object.values(dynamicLayoutInfo)
      ])

      gridView.header.heights = [22, 23]
      gridView.columnByName('route').visible = false
      provider.setRows(gridList)
      gridView.setCheckBar({ syncHeadCheck: true })

      this.gridList = gridList
      this.presGridLength = gridList.length
      provider.setRows(this.gridList)
    },
    updateSorting () {
      const sortedFields = gridView.getSortedFields()
      if (Array.isArray(sortedFields) && sortedFields.length > 0) {
        const routeLengthList = provider.getJsonRows(0, -1).map(row => row.route?.length)
        const maxRouteCount = Math.max(...routeLengthList) > 0 ? Math.max(...routeLengthList) : 0
        const routeColumns = []
        if (maxRouteCount === 1) {
          routeColumns.push('route1')
          routeColumns.push('first')
        } else if (maxRouteCount > 1) {
          for (let i = 0; i < maxRouteCount; i++) {
            routeColumns.push(`route${idx + 1}`)
          }
          routeColumns.push('first')
          routeColumns.push('last')
        }
        const checkMapper = {
          scenarioCd: ['scenarioCd'],
          porCtrYn: ['porCtr'],
          porPlcYn: ['porPlc'],
          dlyCtrYn: ['dlyCtr'],
          dlyPlcYn: ['dlyPlc'],
          routeYn: routeColumns,
          itemYn: ['item', 'itemGrpNm', 'itemNm'],
          cntrSzTypYn: ['cntrSzTyp', 'cntrTyp', 'cntrSz'],
          frtPncYn: ['frtPnc'],
          bidgCstYn: ['bidgCst'],
          bkgShipperYn: ['bkgShipper', 'bkgShipperNm', 'salUnoBs'],
          actShipperYn: ['actShipperNm'],
          hcneShipperYn: ['hcneShipper', 'hcneShipperNm', 'salUnoHcs'],
          profileYn: ['profileNm', 'profileCatNm', 'profileTel', 'profileEml']
        }

        const groupKeyNotChked = Object.keys(this.groupKeyCheck).filter(chk => (this.groupKeyCheck[chk] !== 'Y'))
        const groupKeyRemoved = Object.keys(checkMapper).filter(yn => groupKeyNotChked.includes(yn))
        const columnNmRemoved = [].concat(...groupKeyRemoved.map(key => checkMapper[key]))
        const newSortedFields = sortedFields.filter(field => !columnNmRemoved.includes(field.orgFieldName))
        const orderByOpt = [
          newSortedFields.map(col => (col.orgFieldName)),
          newSortedFields.map(col => (col.direction)),
          Array(newSortedFields.length).fill('sensitive')
        ]

        gridView.orderBy(...orderByOpt)
      }
    },
    updateGridVisibleOpt (typ) {
      if (typ === '' || typ === 'onlyChk') {
        if (this.groupKeyCheck.porCtrYn === 'Y') {
          gridView.columnByName('porCtr').visible = true
        } else {
          gridView.columnByName('porCtr').visible = false
        }
        if (this.groupKeyCheck.porPlcYn === 'Y') {
          gridView.columnByName('porPlc').visible = true
        } else {
          gridView.columnByName('porPlc').visible = false
        }
        if (this.groupKeyCheck.dlyCtrYn === 'Y') {
          gridView.columnByName('dlyCtr').visible = true
        } else {
          gridView.columnByName('dlyCtr').visible = false
        }
        if (this.groupKeyCheck.dlyPlcYn === 'Y') {
          gridView.columnByName('dlyPlc').visible = true
        } else {
          gridView.columnByName('dlyPlc').visible = false
        }
        if (this.groupKeyCheck.itemYn === 'Y') {
          gridView.columnByName('itemGrpNm').visible = true
          gridView.columnByName('itemNm').visible = true
        } else {
          gridView.columnByName('itemGrpNm').visible = false
          gridView.columnByName('itemNm').visible = false
        }
        if (this.groupKeyCheck.cntrSzTypYn === 'Y') {
          gridView.columnByName('cntrSz').visible = true
          gridView.columnByName('cntrTyp').visible = true
        } else {
          gridView.columnByName('cntrSz').visible = false
          gridView.columnByName('cntrTyp').visible = false
        }
        if (this.groupKeyCheck.frtPncYn === 'Y') {
          gridView.columnByName('frtPnc').visible = true
        } else {
          gridView.columnByName('frtPnc').visible = false
        }
        if (this.groupKeyCheck.bidgCstYn === 'Y') {
          gridView.columnByName('bidgCst').visible = true
        } else {
          gridView.columnByName('bidgCst').visible = false
        }
        if (this.groupKeyCheck.bkgShipperYn === 'Y') {
          gridView.columnByName('bkgShipper').visible = true
          gridView.columnByName('bkgShipperNm').visible = true
        } else {
          gridView.columnByName('bkgShipper').visible = false
          gridView.columnByName('bkgShipperNm').visible = false
        }
        if (this.groupKeyCheck.actShipperYn === 'Y') {
          gridView.columnByName('actShipperNm').visible = true
        } else {
          gridView.columnByName('actShipperNm').visible = false
        }
        if (this.groupKeyCheck.hcneShipperYn === 'Y') {
          gridView.columnByName('hcneShipper').visible = true
          gridView.columnByName('hcneShipperNm').visible = true
        } else {
          gridView.columnByName('hcneShipper').visible = false
          gridView.columnByName('hcneShipperNm').visible = false
        }
        if (this.groupKeyCheck.profileYn === 'Y') {
          gridView.columnByName('profileNm').visible = true
          gridView.columnByName('profileCatNm').visible = true
          gridView.columnByName('profileTel').visible = true
          gridView.columnByName('profileEml').visible = true
        } else {
          gridView.columnByName('profileNm').visible = false
          gridView.columnByName('profileCatNm').visible = false
          gridView.columnByName('profileTel').visible = false
          gridView.columnByName('profileEml').visible = false
        }

        // 다중 조건 추가 처리
        if (this.groupKeyCheck.bkgShipperYn === 'Y' && (this.groupKeyCheck.porCtrYn === 'Y' || this.groupKeyCheck.dlyCtrYn === 'Y')) {
          gridView.columnByName('salUnoBs').visible = true
        } else {
          gridView.columnByName('salUnoBs').visible = false
        }
        if (this.groupKeyCheck.hcneShipperYn === 'Y' && (this.groupKeyCheck.porCtrYn === 'Y' || this.groupKeyCheck.dlyCtrYn === 'Y')) {
          gridView.columnByName('salUnoHcs').visible = true
        } else {
          gridView.columnByName('salUnoHcs').visible = false
        }
      }
    },
    async getConfirmShipperInfo () {
      if (gridView.getCheckedItems().length === 0 && this.targetInfo.allShipperYn !== 'Y') {
        this.openAlert(this.$t('cp.CTRL020G070.090'))
        return
      }

      this.groupKeyCheck.confirmTargetYn = 'N'
      this.setChkValue()

      const confirmShipperInfoRes = await scenarioTargetSet.targetConfirmed(this.groupKeyCheck, provider.getJsonRows()).catch(err => { console.log(err) })
      this.confirmShipperInfo = confirmShipperInfoRes.data

      if (this.confirmShipperInfo.length > 0) {
        this.openPopup('ConfirmTargetPop', 'confirmTarget')
      } else {
        this.asyncAlert(this.$t('cp.CTRL020G070.091'), 'target')
      }
    },
    async getTargetFactorInfo () {
      if (gridView.getCheckedItems().length === 0 && this.targetInfo.allShipperYn !== 'Y') {
        this.openAlert(this.$t('cp.CTRL020G070.090'))
        return
      }
      let checkedItems = gridView.getCheckedItems(true)
      let checkRows = gridView.getJsonRows(0, -1)
      this.tempList = []
      for (let i = 0; i < checkedItems.length; i++) {
        this.tempList.push(checkRows[checkedItems[i]])
      }

      this.groupKeyCheck.confirmTargetYn = 'N'
      this.setChkValue()
      this.openPopup('TargetFactorCalcPop', 'targetFactorCalc')
    },
    target () {
      this.groupKeyCheck.scenarioCd = this.scenarioCd
      this.groupKeyCheck.confirmTargetYn = 'Y'
      this.setChkValue()

      scenarioTargetSet.targetConfirmed(this.groupKeyCheck, provider.getJsonRows()).then(response => {
        this.openAlert(this.$t('cp.CTRL020G070.092'))
        this.targetConfirmed = true
        this.confirmChk = 'Y'
      }).catch(err => {
        console.log(err)
      })
    },
    async mcs () {
      const isEmptyMcsScenarioCd = ['', undefined, null].includes(this.targetInfo.mcsScenarioCd)
      const required = ['bkgShipperYn', 'profileYn'].map(key => this.groupKeyCheck[key])
      const isOnlyRequired = required.every(yn => yn === 'Y')
      const isNotChkedItmes = gridView.getCheckedItems().length === 0
      if (isEmptyMcsScenarioCd) {
        this.openAlert(this.$t('cp.CTRL020G070.147'))
        return
      } else if (!(isOnlyRequired)) {
        this.openAlert(this.$t('cp.CTRL020G070.113'))
        return
      } else if (isNotChkedItmes) {
        this.openAlert(this.$t('cp.CTRL020G070.112'))
        return
      } else {
        const result = await this.asyncAlert(this.$t('cp.CTRL020G070.114'), 'mc')
        if (result) {
          this.setChkValue()
        } else {
          return
        }
      }

      const chkedRows = gridView.getJsonRows().filter(row => row.chk === 'Y')
      await scenarioTargetSet.mcs(this.groupKeyCheck, chkedRows).then(response => {
        switch (response.data) {
          case 'OK': {
            this.openAlert(this.$t('cp.CTRL020G070.115'))
            break
          }
          case 'NO': {
            this.openAlert(this.$t('cp.CTRL020G070.116'))
            break
          }
          case 'ING': {
            this.openAlert(this.$t('cp.CTRL020G070.117'))
            break
          }
          default: {
            const sfErrorContainer = document.createElement('div')
            sfErrorContainer.setAttribute('class', 'cp-inner-container cp-scroll cp-scroll--auto mt10')
            const txt = document.createTextNode(response.data)
            sfErrorContainer.appendChild(txt)
            const msg = `${this.$t('cp.CTRL020G070.118')}<br>${sfErrorContainer.outerHTML}`
            this.openAlert(msg)
            break
          }
        }
      }).catch(err => {
        console.log(err)
      })
    },
    selectPromotion () {
      if (!this.checkSfCommon()) {
        return
      }

      const onConfirm = () => { this.openPopup('SfPromotionPop') }
      const onClose = () => { this.openPopup('SfPromotionActivityPop') }

      let obj = {
        title: this.$t('cp.CTRL020G070.124'),
        alertType: 'normal',
        showXclose: true,
        message: '',
        customClass: 'cp-promotion-selector',
        customIconUrl: 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAAAAAA6fptVAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsMAAA7DAcdvqGQAAAAxSURBVChTY/iPBBgDBwAwXHgBAF8EgRkz58QAAAAASUVORK5CYII=',
        useConfirmBtn: true,
        customConfirmBtnClass: 'button blue lg cp-promotion-button',
        customConfirmBtnText: this.$t('cp.CTRL020G070.125'),
        onConfirm: onConfirm,
        customCloseBtnClass: 'button blue lg cp-promotion-button',
        customCloseBtnText: this.$t('cp.CTRL020G070.126'),
        onClose: onClose
      }

      this.$ekmtcCommon.alert(obj)
    },
    updateCheckState () {
      if (this.groupKeyCheck.isEntry === 'Y' || (!this.targetConfirmed && this.groupKeyCheck.afterEntry === 'Y')) {
        // Filter 추가에 따른 명시적 pass
        // this.checkAllItem()
      } else {
        this.checkByChkValue()
      }
    },
    checkByChkValue () {
      gridView.getJsonRows().forEach((row, idx) => {
        try {
          if (row.chk === 'Y') {
            gridView.checkItem(idx, true)
          } else {
            gridView.checkItem(idx, false)
          }
        } catch (err) {
          // 초기 접속 시에만 발생하는 realgrid 에러에 대한 명시적 pass 처리
          // pass
        }
      })
    },
    checkAllItem () {
      provider.getJsonRows(0, -1).forEach((_, idx) => {
        gridView.checkItem(idx, true)
      })
    },
    setChkValue () {
      gridView.getJsonRows().forEach((_, idx) => {
        if (gridView.getModel(idx).checked) {
          gridView.setValue(idx, 'chk', 'Y')
        } else {
          gridView.setValue(idx, 'chk', 'N')
        }
      })
    },
    action () {
      this.$router.push({ path: '../scenario-action/' + this.scenarioCd })
    },
    convertCPLocale (expr, strs) {
      const regex = /\${.*?\}/g
      const patternList = expr.match(regex)
      for (let i = 0; i < patternList.length; i++) {
        if (strs[i] !== undefined) {
          expr = expr.replace(patternList[i], strs[i])
        }
      }
      return expr
    },
    validateDate (row) {
      console.log(row)

      if (this.$ekmtcCommon.isNotEmpty(row.periodFr) && this.$ekmtcCommon.isNotEmpty(row.periodTo)) {
        const from = moment(row.periodFr, 'YYYYMMDD')
        const to = moment(row.periodTo, 'YYYYMMDD')
        const gap = to.diff(from, 'days')

        if (gap > 120) {
          this.$ekmtcCommon.alertDefault(this.$t('cp.CTRL020G070.169'))
          return false
        }
      }

      return true
    }
  }
}
</script>
<style>
  input::-webkit-outer-spin-button,
  input::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }

  .cp-relative {
    position: relative;
  }

  .cp-table-fix {
    table-layout: fixed;
  }

  .cp-hr {
    border-top: 1px solid #cecece;
    margin: 0;
  }

  .cp-li--dummy .cp-hr {
    border-top: 1px dashed #cecece;
    width: 100%;
  }

  .cp-scroll {
    overflow-y: overlay;
    overflow-x: clip;
  }

  .cp-scroll--auto {
    overflow-y: auto;
  }

  .cp-scroll::-webkit-scrollbar {
    width: 10px;
    height: 10px;
  }

  .cp-scroll::-webkit-scrollbar-track {
    background-color: #e3e3e3;
  }

  .cp-grid .cp-scroll::-webkit-scrollbar-track {
    border-top-right-radius: 10px;
    border-bottom-right-radius: 10px;
  }

  .cp-scroll::-webkit-scrollbar-thumb {
    background-color: #babac0;
    border-radius: 10px;
    border: 5px solid #ffffff00;
  }

  .cp-scroll::-webkit-scrollbar-button {
    display: none;
  }

  .cp-parentnode > h2 {
    margin-top: 8px !important;
    margin-bottom: 0px !important;
  }

  .cp-unitbox {
    position: absolute;
    z-index: 10;
    min-width: 150px;
    border: 1px solid #b4b4b4;
    background-color: #ffffff;
    box-shadow: 0px 12px 26px 6px #a7a7a780;
    user-select: none;
  }

  .cp-unitbox.cp-popt {
    border-radius: 10px;
  }

  .cp-unitbox > * {
    position: relative;
  }

  .cp-psel {
    text-align: left;
    line-height: 24px;
    cursor: default;
    height: 24px;
    padding: 0 20px 0 5px;
    border: solid 1px #cecece;
    font-size: 13px;
    letter-spacing: -1px;
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
    background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAMAAADXqc3KAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAyNpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDYuMC1jMDAzIDc5LjE2NDUyNywgMjAyMC8xMC8xNS0xNzo0ODozMiAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvIiB4bWxuczp4bXBNTT0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL21tLyIgeG1sbnM6c3RSZWY9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZVJlZiMiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIDIyLjEgKFdpbmRvd3MpIiB4bXBNTTpJbnN0YW5jZUlEPSJ4bXAuaWlkOkQ2NUMwQjRFRjU4MzExRUJCNUJEQzFCQTJGRjAyRTYwIiB4bXBNTTpEb2N1bWVudElEPSJ4bXAuZGlkOkQ2NUMwQjRGRjU4MzExRUJCNUJEQzFCQTJGRjAyRTYwIj4gPHhtcE1NOkRlcml2ZWRGcm9tIHN0UmVmOmluc3RhbmNlSUQ9InhtcC5paWQ6RDY1QzBCNENGNTgzMTFFQkI1QkRDMUJBMkZGMDJFNjAiIHN0UmVmOmRvY3VtZW50SUQ9InhtcC5kaWQ6RDY1QzBCNERGNTgzMTFFQkI1QkRDMUJBMkZGMDJFNjAiLz4gPC9yZGY6RGVzY3JpcHRpb24+IDwvcmRmOlJERj4gPC94OnhtcG1ldGE+IDw/eHBhY2tldCBlbmQ9InIiPz4h6VXxAAAATlBMVEWPj4/o6OiQkJDMzMzOzs7j4+Oamprk5OSSkpKOjo6NjY3Q0NDl5eXHx8fIyMjPz8/m5ubNzc2RkZHLy8vS0tLJycnV1dXn5+f////////PBEJmAAAAGnRSTlP/////////////////////////////////ABQiANoAAABISURBVHjaYpDEARiGlwQvJ7sECLBy8aFKSIgyCADFeRiEJdAkJJiZGCXEGQQlMCQkWDjEhPglsEhIcLOJSGBIDPvQxQQAAQYA98E2rkH8+7gAAAAASUVORK5CYII=) no-repeat right 50%;
    width: 100%;
    font-weight: 300;
    vertical-align: middle;
    font-family: 'Noto Sans KR', sans-serif;
    word-wrap: normal;
    text-transform: none;
    margin: 0;
  }

  .cp-psel:disabled {
    border: 1px solid #e1e1e1;
    color: #b7b7b7 !important;
    background: #f9f9f9 url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAMAAADXqc3KAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAyNpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDYuMC1jMDAzIDc5LjE2NDUyNywgMjAyMC8xMC8xNS0xNzo0ODozMiAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvIiB4bWxuczp4bXBNTT0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL21tLyIgeG1sbnM6c3RSZWY9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZVJlZiMiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIDIyLjEgKFdpbmRvd3MpIiB4bXBNTTpJbnN0YW5jZUlEPSJ4bXAuaWlkOkUyQ0M3MDRDRjU4MzExRUI4QURCRTM4RDNCNTU3RTUzIiB4bXBNTTpEb2N1bWVudElEPSJ4bXAuZGlkOkUyQ0M3MDRERjU4MzExRUI4QURCRTM4RDNCNTU3RTUzIj4gPHhtcE1NOkRlcml2ZWRGcm9tIHN0UmVmOmluc3RhbmNlSUQ9InhtcC5paWQ6RTJDQzcwNEFGNTgzMTFFQjhBREJFMzhEM0I1NTdFNTMiIHN0UmVmOmRvY3VtZW50SUQ9InhtcC5kaWQ6RTJDQzcwNEJGNTgzMTFFQjhBREJFMzhEM0I1NTdFNTMiLz4gPC9yZGY6RGVzY3JpcHRpb24+IDwvcmRmOlJERj4gPC94OnhtcG1ldGE+IDw/eHBhY2tldCBlbmQ9InIiPz4Bnl+bAAAAKlBMVEXPz8/k5OTOzs7t7e3u7u7s7Ozl5eXm5ubj4+PS0tLn5+fi4uL29vb///9dVj3DAAAADnRSTlP/////////////////AEXA3MgAAABESURBVHja3NDLAYAgEAPRsHwWdei/XfCoqw0wx7xbNH7SXnBZ5a5afwLd8tqzEi8gqVDWHoCmU40PwA8nwPbvxqYAAwAEZRw7sBHRUAAAAABJRU5ErkJggg==) no-repeat right 50% !important;
  }

  .cp-psel::placeholder {
    color: #000000;
  }

  .cp-psel:disabled::placeholder {
    color: #b7b7b7;
  }

  .cp-psel:focus {
    border-color: #0641b8 !important;
    outline: none;
  }

  .cp-popt--close {
    display: none;
  }

  .cp-popt .cp-ul {
    border-bottom-left-radius: 10px;
    border-bottom-right-radius: 10px;
  }

  .cp-li-header {
    padding: 8px 13px 8px 11px;
  }

  .cp-li-header--condition {
    min-height: 30px;
    font-size: 13px;
    cursor: pointer;
    border-bottom: 1px solid #cecece;
  }

  .cp-realfiltering .cp-li-header {
    background-color: #ffffff;
  }

  .cp-ul {
    max-height: 300px;
    text-align: left;
    font-weight: 400;
    font-size: 13px;
    text-align: left;
    user-select: none;
  }

  .cp-ul--hide {
    height: 1px;
    border-top: 1px solid #cecece;
    padding-right: 15px;
  }

  .cp-ul--hide .cp-li {
    height: inherit;
    color: #ffffff00;
  }

  .cp-ul--blank {
    background-color: #f6f6f6;
  }

  .cp-li {
    white-space: nowrap;
    height: 30px;
    display: flex;
    flex-direction: row;
    align-items: center;
    cursor: pointer;
    background-color: #ffffff;
  }

  .cp-ul--ctr .cp-li {
    padding: 0px 11px 0px 12px;
  }

  .cp-ul--plc .cp-li {
    padding: 0px 11px 0px 11px;
  }

  .cp-li > span {
    position: relative;
    left: 5px;
  }

  .cp-popt .cp-li:hover,
  .cp-ul--ctr:not(:hover) .cp-li--selected,
  .cp-ul--plc .cp-li--selected,
  .cp-grid .cp-ul:not(:hover) .cp-li--selected,
  .cp-ul--cond .cp-li:hover,
  .cp-ul--vals .cp-li:hover,
  .cp-ul--cond .cp-li--selected,
  .cp-ul--vals .cp-li--selected {
    background-color: #eaebf2 !important;
    color: #075bb9 !important;
  }

  .cp-li--dummy {
    pointer-events: none;
    height: 1px;
  }

  .cp-pchkbox--disabled {
    cursor: default;
    pointer-events: none;
  }

  .cp-pchkbox--disabled:before {
    background-position: 0 -54px !important;
  }

  .cp-pchkbox--hide {
    display: none !important;
  }

  .cp-pchkbox--selected:before {
    background-position: 0 -18px !important;
  }

  .cp-li--hide {
    display: none;
  }

  .cp-th-button {
    display: inline-flex;
    align-items: center;
    gap: 10px;
    cursor: pointer;
  }

  th:has(> .cp-th-button.disabled) {
    color: #aaaaaa;
    border-top: solid 1px #e1e1e1;
    border-bottom: solid 1px #e1e1e1;
    background-color: #f6f6f6;
  }

  .cp-th-button.disabled {
    pointer-events: none !important;
  }

  .cp-th-button > div {
    font-size: 20px;
  }

  .cp-td-button {
    width: 100%;
    height: 24px !important;
    text-align: left;
    box-sizing: border-box;
    padding: 0 5px !important;
    color: #000000 !important;
    border: solid 1px #cecece !important;
    border-radius: 0px !important;
    background: url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAFrGlUWHRYTUw6Y29tLmFkb2JlLnhtcAAAAAAAPD94cGFja2V0IGJlZ2luPSLvu78iIGlkPSJXNU0wTXBDZWhpSHpyZVN6TlRjemtjOWQiPz4KPHg6eG1wbWV0YSB4bWxuczp4PSJhZG9iZTpuczptZXRhLyIgeDp4bXB0az0iWE1QIENvcmUgNS41LjAiPgogPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4KICA8cmRmOkRlc2NyaXB0aW9uIHJkZjphYm91dD0iIgogICAgeG1sbnM6eG1wPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvIgogICAgeG1sbnM6cGhvdG9zaG9wPSJodHRwOi8vbnMuYWRvYmUuY29tL3Bob3Rvc2hvcC8xLjAvIgogICAgeG1sbnM6ZGM9Imh0dHA6Ly9wdXJsLm9yZy9kYy9lbGVtZW50cy8xLjEvIgogICAgeG1sbnM6ZXhpZj0iaHR0cDovL25zLmFkb2JlLmNvbS9leGlmLzEuMC8iCiAgICB4bWxuczp0aWZmPSJodHRwOi8vbnMuYWRvYmUuY29tL3RpZmYvMS4wLyIKICAgIHhtbG5zOnhtcE1NPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvbW0vIgogICAgeG1sbnM6c3RFdnQ9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZUV2ZW50IyIKICAgeG1wOkNyZWF0ZURhdGU9IjIwMjMtMDctMjBUMTY6NDM6NDErMDkwMCIKICAgeG1wOk1vZGlmeURhdGU9IjIwMjMtMDctMjdUMTM6NDc6MDQrMDk6MDAiCiAgIHhtcDpNZXRhZGF0YURhdGU9IjIwMjMtMDctMjdUMTM6NDc6MDQrMDk6MDAiCiAgIHBob3Rvc2hvcDpEYXRlQ3JlYXRlZD0iMjAyMy0wNy0yMFQxNjo0Mzo0MSswOTAwIgogICBwaG90b3Nob3A6Q29sb3JNb2RlPSIzIgogICBwaG90b3Nob3A6SUNDUHJvZmlsZT0ic1JHQiBJRUM2MTk2Ni0yLjEiCiAgIGV4aWY6UGl4ZWxYRGltZW5zaW9uPSIyNCIKICAgZXhpZjpQaXhlbFlEaW1lbnNpb249IjI0IgogICBleGlmOkNvbG9yU3BhY2U9IjEiCiAgIHRpZmY6SW1hZ2VXaWR0aD0iMjQiCiAgIHRpZmY6SW1hZ2VMZW5ndGg9IjI0IgogICB0aWZmOlJlc29sdXRpb25Vbml0PSIyIgogICB0aWZmOlhSZXNvbHV0aW9uPSI5Ni8xIgogICB0aWZmOllSZXNvbHV0aW9uPSI5Ni8xIj4KICAgPGRjOnRpdGxlPgogICAgPHJkZjpBbHQ+CiAgICAgPHJkZjpsaSB4bWw6bGFuZz0ieC1kZWZhdWx0Ij5sZW5zPC9yZGY6bGk+CiAgICA8L3JkZjpBbHQ+CiAgIDwvZGM6dGl0bGU+CiAgIDx4bXBNTTpIaXN0b3J5PgogICAgPHJkZjpTZXE+CiAgICAgPHJkZjpsaQogICAgICBzdEV2dDphY3Rpb249InByb2R1Y2VkIgogICAgICBzdEV2dDpzb2Z0d2FyZUFnZW50PSJBZmZpbml0eSBQaG90byAyIDIuMS4xIgogICAgICBzdEV2dDp3aGVuPSIyMDIzLTA3LTI3VDEzOjQ3OjA0KzA5OjAwIi8+CiAgICA8L3JkZjpTZXE+CiAgIDwveG1wTU06SGlzdG9yeT4KICA8L3JkZjpEZXNjcmlwdGlvbj4KIDwvcmRmOlJERj4KPC94OnhtcG1ldGE+Cjw/eHBhY2tldCBlbmQ9InIiPz4astIkAAABgmlDQ1BzUkdCIElFQzYxOTY2LTIuMQAAKJF1kc8rRFEUxz8GjR+jUSwUi0lYzWiMmthYjBgKizHKYDPz5peaH6/3RpKtsp2ixMavBX8BW2WtFJGSLWtiw/ScNzM1k8y5nXs+93vvOd17LliCKSWtN7ghnclpAb/PsRhaclhfsdJNAy6aw4quzs5PBqlpXw/UmfHOZdaqfe5fa43GdAXqmoTHFFXLCU8Jz6znVJN3hTuVZDgqfC7s1OSCwvemHinxm8mJEv+YrAUD42BpF3YkqjhSxUpSSwvLy+lLp9aU8n3Ml9himYV5ib3iPegE8OPDwTQTjONliFGZvdIdD4Oyoka+u5g/R1ZyFZlVNtBYJUGSHE5R16R6TGJc9JiMFBtm///2VY8Pe0rVbT5ofDGMj36w7kAhbxjfx4ZROIH6Z7jKVPKzRzDyKXq+ovUdgn0LLq4rWmQPLreh60kNa+GiVC9uicfh/QzaQtBxCy3LpZ6V9zl9hOCmfNUN7B/AgJy3r/wCYPZn43Ablv4AAAAJcEhZcwAADsQAAA7EAZUrDhsAAAHESURBVEiJ7dKxaxphGAbwJ1ViLpVQsPAZiZ6J0A+kdpBmcEqECkVvcW2gTjfkT3DJHyCEbBIQLBRxKAohRdzVQzAiPTgq6WClUM2Zj4J6GSQ506mQ4RKTcyr4jO/D9/744AUWWQQA2u32p3q9fqsoyslT3y49VDYajS+FQuGtpmmrAAgAxnGcJgjCeTgcfj8XUKvVvubz+TcAlpxO58Tj8VwxxlY6nQ4HAIIgdKPR6M4swHpfUSwWXwNAPB7/EYlE3v2bt1qtz9lsdqdcLvOqqm4TQs4eAp4ZDSuVSm8ymTj9fr92dzkABIPBj6FQiOm6zjebzcNZPzAEBoPBOoAVSumFUe/z+X4CAGNszRTAcRwAYDQaPTfqx+PxCwCw2WzXpgBK6QGAX5IkEaO+Wq16AfymlH6fBdx7Rel0WlEUZdPhcFzEYrFvLperxBjbLZVKoX6//9Ltdl8mk8lXpgEASKVS591u1w7AdXdutVohiuJxIBDYnwsAAEmSTmVZ3hoOh8t2u/2G5/k/siyT6XSKRCJx5PV603MBRlFVdTuTyeR1XZ+JmAKeghhe0WNCCDkTRfGDxWJBLpfb6/V6G2Z3LfKf5y+ysa1SVFgtlQAAAABJRU5ErkJggg==') no-repeat center right;
  }

  .cp-td-button.disabled {
    border: 1px solid #e1e1e1 !important;
    color: #b7b7b7 !important;
    background: #f9f9f9 url('data:image/png;base64,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')  no-repeat center right;
  }

  .cp-td-button:active {
    border: 1px solid #003193 !important;
    color: #003193 !important;
  }

  .cp-td-button .cp-short-text {
    display: block;
    width: calc(100% - 16px);
    height: inherit;
    overflow: hidden;
    white-space: nowrap;
  }

  .cp-parentnode > .cp-flex {
    display: flex !important;
    align-items: center;
    justify-content: space-between;
    gap: 3px;
  }

  .cp-logicoper {
    font-size: 12px;
    font-weight: 400;
    text-align: center;
    vertical-align: middle;
    height: 24px;
    line-height: 24px;
    padding: 0 5px;
    color: #000000;
    background-color: #f6f6f6;
    border: 1px solid #e1e1e1;
    border-radius: 5px;
  }

  .cp-logicoper--and {
    display: inline-block !important;
  }

  .cp-logicoper--or {
    display: block;
    margin-left: auto;
    margin-right: auto;
    width: 50px;
    height: 35px;
    line-height: 35px;
    font-size: 18px;
  }

  /* https://docs.realgrid.com/guides/grid-style/realgrid-2-custom-styles-3-data */
  .cp-parentnode .rg-header-sort-ascending,
  .cp-parentnode .rg-header-sort-descending,
  .cp-parentnode .rg-header-filtering {
    transform: translateX(-3px);
  }

  .cp-parentnode .rg-header-filtering {
    background: url(data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz48c3ZnIHZlcnNpb249IjEuMSIgaWQ9IkxheWVyXzEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiIHg9IjBweCIgeT0iMHB4IiB2aWV3Qm94PSIwIDAgMTYgMTYiIHN0eWxlPSJlbmFibGUtYmFja2dyb3VuZDpuZXcgMCAwIDE2IDE2OyIgeG1sOnNwYWNlPSJwcmVzZXJ2ZSI+PHN0eWxlIHR5cGU9InRleHQvY3NzIj4uc3Qxe2ZpbGw6I0UxRTFFMTt9LnN0MntmaWxsOiNGRkZGRkY7fS5zdDN7ZmlsbDojMDc1QkI5O308L3N0eWxlPjxwb2x5Z29uIGNsYXNzPSJzdDEiIHBvaW50cz0iMTQsMiAyLDIgMiwzIDYsNyA2LDE0IDEwLDEyIDEwLDcgMTQsMyAiLz48L3N2Zz4=) no-repeat center;
    cursor: pointer !important;
    border-radius: 3px;
  }

  .cp-parentnode .rg-header-filtering:hover,
  .cp-parentnode .rg-header-filtering--target {
    background-image: url(data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz48c3ZnIHZlcnNpb249IjEuMSIgaWQ9IkxheWVyXzEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiIHg9IjBweCIgeT0iMHB4IiB2aWV3Qm94PSIwIDAgMTYgMTYiIHN0eWxlPSJlbmFibGUtYmFja2dyb3VuZDpuZXcgMCAwIDE2IDE2OyIgeG1sOnNwYWNlPSJwcmVzZXJ2ZSI+PHN0eWxlIHR5cGU9InRleHQvY3NzIj4uc3Qxe2ZpbGw6I0UxRTFFMTt9LnN0MntmaWxsOiNGRkZGRkY7fS5zdDN7ZmlsbDojMDc1QkI5O308L3N0eWxlPjxwb2x5Z29uIGNsYXNzPSJzdDIiIHBvaW50cz0iMTQsMiAyLDIgMiwzIDYsNyA2LDE0IDEwLDEyIDEwLDcgMTQsMyAiLz48L3N2Zz4=), linear-gradient(to right, #075BB9, #075BB9) !important;
    background-repeat: no-repeat, no-repeat;
    background-position: center, center;
  }

  .cp-parentnode .rg-header-filtering.filter-activated {
    background: url(data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz48c3ZnIHZlcnNpb249IjEuMSIgaWQ9IkxheWVyXzEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiIHg9IjBweCIgeT0iMHB4IiB2aWV3Qm94PSIwIDAgMTYgMTYiIHN0eWxlPSJlbmFibGUtYmFja2dyb3VuZDpuZXcgMCAwIDE2IDE2OyIgeG1sOnNwYWNlPSJwcmVzZXJ2ZSI+PHN0eWxlIHR5cGU9InRleHQvY3NzIj4uc3Qxe2ZpbGw6I0UxRTFFMTt9LnN0MntmaWxsOiNGRkZGRkY7fS5zdDN7ZmlsbDojMDc1QkI5O308L3N0eWxlPjxwb2x5Z29uIGNsYXNzPSJzdDMiIHBvaW50cz0iMTQsMiAyLDIgMiwzIDYsNyA2LDE0IDEwLDEyIDEwLDcgMTQsMyAiLz48L3N2Zz4=) no-repeat center;
  }

  .cp-parentnode .rg-selection-cell {
    background: #0000ff40 !important;
    color: inherit;
  }

  .cp-parentnode .rg-selection {
    background: rgba(21, 139, 229, 0.2) !important;
    border: 1px solid rgba(21, 66, 229, 0.67);
  }

  .cp-oldfiltering {
    width: 1px !important;
    height: 1px !important;
    top: -500px !important;
    left: -500px !important;
  }

  .cp-realfiltering {
    width: 270px;
  }

  .cp-realfiltering input[type="text"] {
    width: 100%;
  }

  .cp-realfiltering .cp-ul {
    min-height: 30px;
    max-height: 150px;
  }

  .cp-pth {
    height: 30px;
    line-height: 30px;
    padding: 0 11px;
    font-size: 14px;
    font-weight: 500;
    color: #075bb9;
    background-color: #f6f9ff;
    cursor: pointer;
    border-bottom: 1px solid #cecece;
  }

  .cp-pth > a.button {
    width: 55px;
  }

  /* https://stackoverflow.com/questions/5087420/how-to-rotate-the-background-image-in-the-container */
  .cp-pth:first-child:before {
    width: 24px;
    height: 24px;
    float: right;
    content: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAMAAADXqc3KAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAyNpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDYuMC1jMDAzIDc5LjE2NDUyNywgMjAyMC8xMC8xNS0xNzo0ODozMiAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvIiB4bWxuczp4bXBNTT0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL21tLyIgeG1sbnM6c3RSZWY9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZVJlZiMiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIDIyLjEgKFdpbmRvd3MpIiB4bXBNTTpJbnN0YW5jZUlEPSJ4bXAuaWlkOkQ2NUMwQjRFRjU4MzExRUJCNUJEQzFCQTJGRjAyRTYwIiB4bXBNTTpEb2N1bWVudElEPSJ4bXAuZGlkOkQ2NUMwQjRGRjU4MzExRUJCNUJEQzFCQTJGRjAyRTYwIj4gPHhtcE1NOkRlcml2ZWRGcm9tIHN0UmVmOmluc3RhbmNlSUQ9InhtcC5paWQ6RDY1QzBCNENGNTgzMTFFQkI1QkRDMUJBMkZGMDJFNjAiIHN0UmVmOmRvY3VtZW50SUQ9InhtcC5kaWQ6RDY1QzBCNERGNTgzMTFFQkI1QkRDMUJBMkZGMDJFNjAiLz4gPC9yZGY6RGVzY3JpcHRpb24+IDwvcmRmOlJERj4gPC94OnhtcG1ldGE+IDw/eHBhY2tldCBlbmQ9InIiPz4h6VXxAAAATlBMVEWPj4/o6OiQkJDMzMzOzs7j4+Oamprk5OSSkpKOjo6NjY3Q0NDl5eXHx8fIyMjPz8/m5ubNzc2RkZHLy8vS0tLJycnV1dXn5+f////////PBEJmAAAAGnRSTlP/////////////////////////////////ABQiANoAAABISURBVHjaYpDEARiGlwQvJ7sECLBy8aFKSIgyCADFeRiEJdAkJJiZGCXEGQQlMCQkWDjEhPglsEhIcLOJSGBIDPvQxQQAAQYA98E2rkH8+7gAAAAASUVORK5CYII=);
    transform: rotate(180deg) translateY(-4px);
  }

  .cp-realfiltering:has(.cp-dropdown--close) .cp-pth:before {
    transform: translateY(5px);
  }

  .cp-dropdown {
    border-bottom: 1px solid #cecece;
  }

  .cp-dropdown--close {
    display: none !important;
  }

  .cp-realfiltering .cp-grid .cp-ul {
    border-top-left-radius: 10px;
  }

  .cp-realfiltering .cp-grid .cp-li {
    padding: 0 5px;
    width: 185px;
  }

  .cp-ul--cond .cp-li,
  .cp-ul--vals .cp-li {
    padding: 0px 13px 0 11px;
  }

  .cp-dropdown > .cp-grid {
    padding: 11px;
    display: grid;
    gap: 5px;
  }

  .cp-dropdown > .cp-grid--typeN,
  .cp-dropdown > .cp-grid--typeQ {
    grid-template-columns: repeat(12, 1fr);
    grid-template-rows: repeat(2, 1fr);
    grid-template-areas:
      "a a a a b b b b b b b b"
      "e e e e e e f f f f f f"
  }

  .cp-dropdown > .cp-grid--typeN > :nth-child(1),
  .cp-dropdown > .cp-grid--typeQ > :nth-child(1) {
    grid-area: a;
  }

  .cp-dropdown > .cp-grid--typeN > :nth-child(2),
  .cp-dropdown > .cp-grid--typeQ > :nth-child(2) {
    grid-area: b;
  }

  .cp-dropdown > .cp-grid--typeN > :nth-child(3),
  .cp-dropdown > .cp-grid--typeQ > :nth-child(3) {
    grid-area: e;
  }

  .cp-dropdown > .cp-grid--typeN > :nth-child(4),
  .cp-dropdown > .cp-grid--typeQ > :nth-child(4) {
    grid-area: f;
  }

  .cp-dropdown > .cp-grid--typeB {
    grid-template-columns: repeat(12, 1fr);
    grid-template-rows: repeat(2, 1fr);
    grid-template-areas:
      "a a a a b b b c c d d d"
      "e e e e e e f f f f f f"
  }

  .cp-dropdown > .cp-grid--typeB > :nth-child(1) {
    grid-area: a;
  }

  .cp-dropdown > .cp-grid--typeB > :nth-child(2) {
    grid-area: b;
  }

  .cp-dropdown > .cp-grid--typeB > :nth-child(3) {
    grid-area: c;
  }

  .cp-dropdown > .cp-grid--typeB > :nth-child(4) {
    grid-area: d;
  }

  .cp-dropdown > .cp-grid--typeB > :nth-child(5) {
    grid-area: e;
  }

  .cp-dropdown > .cp-grid--typeB > :nth-child(6) {
    grid-area: f;
  }

  .cp-dropdown > .cp-grid--typeP {
    grid-template-columns: repeat(12, 1fr);
    grid-template-rows: repeat(2, 1fr);
    grid-template-areas:
      "a a a a b b b b b c c c"
      "e e e e e e f f f f f f"
  }

  .cp-dropdown > .cp-grid--typeP > :nth-child(1) {
    grid-area: a;
  }

  .cp-dropdown > .cp-grid--typeP > :nth-child(2) {
    grid-area: b;
  }

  .cp-dropdown > .cp-grid--typeP > :nth-child(3) {
    grid-area: c;
  }

  .cp-dropdown > .cp-grid--typeP > :nth-child(4) {
    grid-area: e;
  }

  .cp-dropdown > .cp-grid--typeP > :nth-child(5) {
    grid-area: f;
  }

  .cp-excel-title {
    font-size: 18px;
    font-weight: bold;
  }

  .cp-tgt-header {
    background-color: #eaeff9 !important;
  }

  .cp-tgt-column {
    background-color: #f0f5fc !important;
  }

  .cp-tgt-column:hover {
    background-color: #eaeff9 !important;
  }

  .cp-inner-container {
    margin: 10px auto 0;
    min-height: 20px;
    height: auto;
    max-height: 80px;
    text-align: left;
    max-width: 400px;
  }

  .cp-promotion-selector .simplert__content {
    width: 450px;
    height: 300px;
  }

  .cp-promotion-selector .simplert__icon {
    height: 10px !important;
  }

  .cp-promotion-selector .simplert__icon img {
    height: inherit;
  }

  .cp-promotion-button {
    display: block;
    width: 370px;
    height: 40px !important;
    line-height: 40px !important;
    font-weight: 500 !important;
    font-size: 14px !important;
  }

  .cp-promotion-button:first-child {
    margin: 10px auto 30px;
  }

  .cp-promotion-button:last-child {
    margin: 0 auto;
  }
</style>
